<template>
  <div class="img_contrast">
    <div class="img_zoom">
      <motion
        v-bind:zoomsize="zoomsizes"
        @setzoomsize="setzoomsize"
        :index="index"
      >
        <!-- 拖动组件 -->
        <div v-if="comparison_div1" style="width: 100%; height: 100%">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 828.85 586.06"
          >
            <!-- <defs>
              <clipPath id="clip-path" transform="translate(0 0)">
                <rect class="cls-1" width="828.85" height="586.06" />
              </clipPath>
              <clipPath id="clip-path-3" transform="translate(0 0)">
                <rect
                  class="cls-1"
                  x="35.38"
                  y="68.17"
                  width="705.04"
                  height="364.7"
                />
              </clipPath>
            </defs> -->
            <g id="图层_2" data-name="图层 2">
              <g id="page_A" data-name="page A">
                <g class="cls-2">
                  <rect class="cls-3" width="828.85" height="586.06" />
                  <text class="cls-4" transform="translate(34.3 88.12)">
                    Unit
                  </text>
                  <text class="cls-4" transform="translate(34.3 123.56)">
                    Di
                    <tspan class="cls-5" x="28.15" y="0">s</tspan>
                    <tspan x="43.3" y="0">tri</tspan>
                    <tspan class="cls-6" x="72.33" y="0">b</tspan>
                    <tspan x="92.15" y="0">uti</tspan>
                    <tspan class="cls-7" x="129.07" y="0">o</tspan>
                    <tspan x="147.7" y="0">n</tspan>
                  </text>
                  <rect
                    class="cls-8"
                    x="35.3"
                    y="456.01"
                    width="140.02"
                    height="37.18"
                  />
                  <rect
                    class="cls-9"
                    x="176.55"
                    y="456.01"
                    width="140.02"
                    height="37.18"
                  />
                  <rect
                    class="cls-10"
                    x="317.8"
                    y="456.01"
                    width="140.02"
                    height="37.18"
                  />
                  <rect
                    class="cls-11"
                    x="459.05"
                    y="456.01"
                    width="140.02"
                    height="37.18"
                  />
                  <rect
                    class="cls-12"
                    x="600.29"
                    y="456.01"
                    width="140.02"
                    height="37.18"
                  />
                  <rect
                    class="cls-13"
                    x="35.3"
                    y="494.42"
                    width="140.02"
                    height="37.18"
                  />
                  <rect
                    class="cls-14"
                    x="176.55"
                    y="494.42"
                    width="140.02"
                    height="37.18"
                  />
                  <rect
                    class="cls-15"
                    x="317.8"
                    y="494.42"
                    width="140.02"
                    height="37.18"
                  />
                  <rect
                    class="cls-16"
                    x="459.05"
                    y="494.42"
                    width="140.02"
                    height="37.18"
                  />
                  <text class="cls-17" transform="translate(74.49 478.52)">
                    1 BEDROOM
                  </text>
                  <text class="cls-17" transform="translate(50.38 516.09)">
                    1 BEDROOM + STUDY
                  </text>
                  <text class="cls-17" transform="translate(213.66 478.52)">
                    2 BEDROOM
                  </text>
                  <text class="cls-17" transform="translate(189.55 516.09)">
                    2 BEDROOM + STUDY
                  </text>
                  <text class="cls-17" transform="translate(330.96 478.52)">
                    2 BEDROOM + GUEST
                  </text>
                  <text class="cls-17" transform="translate(354.96 516.09)">
                    3 BEDROOM
                  </text>
                  <text class="cls-17" transform="translate(471.87 478.52)">
                    3 BEDROOM + GUEST
                  </text>
                  <text class="cls-17" transform="translate(495.68 516.09)">
                    4 BEDROOM
                  </text>
                  <text class="cls-18" transform="translate(607.3 473.81)">
                    COMMUNAL FACILITIES
                  </text>
                  <text class="cls-18" transform="translate(659.56 484.05)">
                    (CF)
                  </text>
                  <g class="cls-2">
                    <g class="cls-19">
                      <g class="cls-20">
                        <path
                          class="cls-21"
                          d="M739.32,102.4H229.1V69.27H739.32Zm1.09-34.23H228v35.32H740.41Z"
                          transform="translate(0 0)"
                        />
                        <path
                          class="cls-21"
                          d="M739.32,431.77H36.47V398.65H739.32Zm1.09-34.22h-705v35.32h705Z"
                          transform="translate(0 0)"
                        />
                        <path
                          class="cls-21"
                          d="M739.32,397.55H197V362.1H739.32ZM740.41,361H195.9v37.64H740.41Z"
                          transform="translate(0 0)"
                        />
                        <path
                          class="cls-21"
                          d="M97.22,397.55H36.47v-35.5H97.22ZM98.32,361H35.38v37.69H98.32Z"
                          transform="translate(0 0)"
                        />
                      </g>
                    </g>
                  </g>
                  <text class="cls-22" transform="translate(752.83 386.82)">
                    1
                  </text>
                  <text class="cls-23" transform="translate(763.01 378.87)">
                    ST
                  </text>
                  <text class="cls-24" transform="translate(763.01 386.83)">
                    STOREY
                  </text>
                  <text class="cls-22" transform="translate(748.49 350.22)">
                    2
                  </text>
                  <text class="cls-23" transform="translate(763.01 342.27)">
                    ND
                  </text>
                  <text class="cls-24" transform="translate(763.01 350.23)">
                    STOREY
                  </text>
                  <text class="cls-22" transform="translate(748.17 313.62)">
                    3
                  </text>
                  <text class="cls-23" transform="translate(763.01 305.68)">
                    RD
                  </text>
                  <text class="cls-24" transform="translate(763.01 313.63)">
                    STOREY
                  </text>
                  <text class="cls-22" transform="translate(747.05 277.02)">
                    4
                  </text>
                  <text class="cls-23" transform="translate(763.01 269.08)">
                    TH
                  </text>
                  <text class="cls-24" transform="translate(763.01 277.03)">
                    STOREY
                  </text>
                  <text class="cls-22" transform="translate(747.89 240.42)">
                    5
                  </text>
                  <text class="cls-23" transform="translate(763.01 232.48)">
                    TH
                  </text>
                  <text class="cls-24" transform="translate(763.01 240.43)">
                    STOREY
                  </text>
                  <text class="cls-22" transform="translate(747.53 203.82)">
                    6
                  </text>
                  <text class="cls-23" transform="translate(763.01 195.88)">
                    TH
                  </text>
                  <text class="cls-24" transform="translate(763.01 203.84)">
                    STOREY
                  </text>
                  <text class="cls-22" transform="translate(749.8 167.23)">
                    7
                  </text>
                  <text class="cls-23" transform="translate(763.01 159.28)">
                    TH
                  </text>
                  <text class="cls-24" transform="translate(763.01 167.24)">
                    STOREY
                  </text>
                  <text class="cls-22" transform="translate(747.3 130.63)">
                    8
                  </text>
                  <text class="cls-23" transform="translate(763.01 122.68)">
                    TH
                  </text>
                  <text class="cls-24" transform="translate(763.01 130.64)">
                    STOREY
                  </text>
                  <text class="cls-23" transform="translate(471.59 89.15)">
                    ROOF
                  </text>
                  <text class="cls-23" transform="translate(445.43 417.74)">
                    CARPARK
                  </text>
                  <text class="cls-23" transform="translate(445.43 381.97)">
                    CARPARK
                  </text>
                  <text class="cls-23" transform="translate(44.27 381.98)">
                    CARPARK
                  </text>
                  <text class="cls-23" transform="translate(748.46 417.75)">
                    BASEMENT
                  </text>
                  <text class="cls-23" transform="translate(748.46 89.15)">
                    ROOF
                  </text>
                  <polygon
                    class="cls-12"
                    points="210.55 177.97 51.56 177.97 35.38 177.97 35.38 213.29 51.56 213.29 210.55 213.29 226.74 213.29 226.74 177.97 210.55 177.97"
                  />
                  <text class="cls-23" transform="translate(77.86 199.42)">
                    COMMUNAL FACILITIES
                  </text>
                  <g id="D" @click="setunitimg('D')">
                    <rect
                      class="cls-14"
                      x="99.59"
                      y="360.96"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-14"
                      x="99.59"
                      y="287.76"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-14"
                      x="99.59"
                      y="324.36"
                      width="30.83"
                      height="35.32"
                    />
                    <text class="cls-25" transform="translate(112.25 372.9)">
                      D
                    </text>
                    <text class="cls-25" transform="translate(103.02 380.86)">
                      <tspan class="cls-26">#01-0</tspan>
                      <tspan x="19.6" y="0">3</tspan>
                    </text>
                    <text class="cls-25" transform="translate(104.05 388.82)">
                      <tspan class="cls-26">6</tspan>
                      <tspan class="cls-27" x="4.21" y="0">7</tspan>
                      <tspan class="cls-26" x="7.79" y="0">s</tspan>
                      <tspan class="cls-28" x="11.22" y="0">q</tspan>
                      <tspan x="15.7" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(112.25 298.72)">
                      D
                    </text>
                    <text class="cls-25" transform="translate(102.37 306.68)">
                      <tspan class="cls-26">#03</tspan>
                      <tspan class="cls-28" x="13.66" y="0">-</tspan>
                      <tspan class="cls-29" x="17.28" y="0">2</tspan>
                      <tspan x="21.08" y="0">0</tspan>
                    </text>
                    <text class="cls-25" transform="translate(104.05 314.64)">
                      <tspan class="cls-26">6</tspan>
                      <tspan class="cls-27" x="4.21" y="0">7</tspan>
                      <tspan class="cls-26" x="7.79" y="0">s</tspan>
                      <tspan class="cls-28" x="11.22" y="0">q</tspan>
                      <tspan x="15.7" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(112.25 335.65)">
                      D
                    </text>
                    <text class="cls-25" transform="translate(102.42 343.61)">
                      <tspan class="cls-26">#02</tspan>
                      <tspan class="cls-28" x="13.57" y="0">-</tspan>
                      <tspan class="cls-29" x="17.19" y="0">2</tspan>
                      <tspan x="20.98" y="0">0</tspan>
                    </text>
                    <text class="cls-25" transform="translate(104.05 351.57)">
                      <tspan class="cls-26">6</tspan>
                      <tspan class="cls-27" x="4.21" y="0">7</tspan>
                      <tspan class="cls-26" x="7.79" y="0">s</tspan>
                      <tspan class="cls-28" x="11.22" y="0">q</tspan>
                      <tspan x="15.7" y="0">m</tspan>
                    </text>
                  </g>
                  <g id="E" @click="setunitimg('E')">
                    <rect
                      class="cls-10"
                      x="131.69"
                      y="360.96"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-10"
                      x="131.69"
                      y="287.76"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-10"
                      x="131.69"
                      y="324.36"
                      width="30.83"
                      height="35.32"
                    />
                    <text class="cls-25" transform="translate(144.71 372.91)">
                      E
                    </text>
                    <text class="cls-25" transform="translate(135.2 380.87)">
                      <tspan class="cls-26">#01</tspan>
                      <tspan class="cls-28" x="11.81" y="0">-</tspan>
                      <tspan class="cls-29" x="15.43" y="0">0</tspan>
                      <tspan x="19.59" y="0">2</tspan>
                    </text>
                    <text class="cls-25" transform="translate(135.96 388.82)">
                      <tspan class="cls-26">82sq</tspan>
                      <tspan x="15.89" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(144.7 298.73)">
                      E
                    </text>
                    <text class="cls-25" transform="translate(135.24 306.69)">
                      <tspan class="cls-26">#03</tspan>
                      <tspan class="cls-28" x="13.66" y="0">-</tspan>
                      <tspan class="cls-29" x="17.28" y="0">1</tspan>
                      <tspan x="19.32" y="0">9</tspan>
                    </text>
                    <text class="cls-25" transform="translate(135.95 314.65)">
                      <tspan class="cls-26">82sq</tspan>
                      <tspan x="15.89" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(144.7 335.66)">
                      E
                    </text>
                    <text class="cls-25" transform="translate(135.29 343.62)">
                      <tspan class="cls-26">#02-1</tspan>
                      <tspan x="19.23" y="0">9</tspan>
                    </text>
                    <text class="cls-25" transform="translate(135.95 351.57)">
                      <tspan class="cls-26">82sq</tspan>
                      <tspan x="15.89" y="0">m</tspan>
                    </text>
                  </g>
                  <g id="G4" @click="setunitimg('G4')">
                    <rect
                      class="cls-11"
                      x="35.38"
                      y="214.56"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-11"
                      x="35.38"
                      y="251.16"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-11"
                      x="35.38"
                      y="287.76"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-11"
                      x="35.38"
                      y="324.36"
                      width="30.83"
                      height="35.32"
                    />
                    <text class="cls-25" transform="translate(46.3 262.73)">
                      <tspan class="cls-28">G</tspan>
                      <tspan x="5.18" y="0">4</tspan>
                    </text>
                    <text class="cls-25" transform="translate(38.78 270.69)">
                      <tspan class="cls-26">#04-2</tspan>
                      <tspan x="21.36" y="0">2</tspan>
                    </text>
                    <text class="cls-30" transform="translate(39.51 278.65)">
                      110sq
                      <tspan class="cls-31" x="16.15" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(46.3 298.69)">
                      <tspan class="cls-28">G</tspan>
                      <tspan x="5.18" y="0">4</tspan>
                    </text>
                    <text class="cls-25" transform="translate(38.94 306.65)">
                      <tspan class="cls-26">#0</tspan>
                      <tspan class="cls-28" x="9.77" y="0">3</tspan>
                      <tspan class="cls-26" x="13.66" y="0">-2</tspan>
                      <tspan x="21.08" y="0">2</tspan>
                    </text>
                    <text class="cls-30" transform="translate(39.51 314.6)">
                      110sq
                      <tspan class="cls-31" x="16.15" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(46.3 335.6)">
                      <tspan class="cls-28">G</tspan>
                      <tspan x="5.18" y="0">4</tspan>
                    </text>
                    <text class="cls-25" transform="translate(38.99 343.56)">
                      <tspan class="cls-26">#02-2</tspan>
                      <tspan x="20.99" y="0">2</tspan>
                    </text>
                    <text class="cls-30" transform="translate(39.51 351.52)">
                      110sq
                      <tspan class="cls-31" x="16.15" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(46.3 226.53)">
                      <tspan class="cls-28">G</tspan>
                      <tspan x="5.18" y="0">4</tspan>
                    </text>
                    <text class="cls-25" transform="translate(38.9 234.49)">
                      <tspan class="cls-26">#05</tspan>
                      <tspan class="cls-28" x="13.93" y="0">-</tspan>
                      <tspan class="cls-29" x="17.55" y="0">2</tspan>
                      <tspan x="21.34" y="0">2</tspan>
                    </text>
                    <text class="cls-30" transform="translate(39.51 242.45)">
                      110sq
                      <tspan class="cls-31" x="16.15" y="0">m</tspan>
                    </text>
                  </g>
                  <g id="H" @click="setunitimg('H')">
                    <rect
                      class="cls-16"
                      x="67.48"
                      y="214.56"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-16"
                      x="67.48"
                      y="251.16"
                      width="30.83"
                      height="35.32"
                    />
                    <text class="cls-25" transform="translate(80.06 262.75)">
                      H
                    </text>
                    <text class="cls-25" transform="translate(70.94 270.71)">
                      <tspan class="cls-26">#04</tspan>
                      <tspan class="cls-28" x="13.94" y="0">-</tspan>
                      <tspan class="cls-29" x="17.56" y="0">2</tspan>
                      <tspan x="21.35" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(71.46 278.67)">
                      <tspan class="cls-26">11</tspan>
                      <tspan class="cls-27" x="4.07" y="0">7</tspan>
                      <tspan class="cls-26" x="7.66" y="0">s</tspan>
                      <tspan class="cls-28" x="11.09" y="0">q</tspan>
                      <tspan x="15.57" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(80.06 226.54)">
                      H
                    </text>
                    <text class="cls-25" transform="translate(71.07 234.5)">
                      <tspan class="cls-26">#05</tspan>
                      <tspan class="cls-28" x="13.93" y="0">-</tspan>
                      <tspan class="cls-29" x="17.55" y="0">2</tspan>
                      <tspan x="21.34" y="0">1</tspan>
                    </text>
                    <text class="cls-30" transform="translate(71.47 242.45)">
                      117s
                      <tspan class="cls-28" x="11.1" y="0">q</tspan>
                      <tspan class="cls-31" x="15.58" y="0">m</tspan>
                    </text>
                  </g>
                  <g id="B1" @click="setunitimg('B1')">
                    <rect
                      class="cls-13"
                      x="99.59"
                      y="251.16"
                      width="30.83"
                      height="35.32"
                    />
                    <text class="cls-25" transform="translate(111.2 262.76)">
                      <tspan class="cls-26">B</tspan>
                      <tspan x="4.05" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(102.2 270.72)">
                      <tspan class="cls-26">#04</tspan>
                      <tspan class="cls-28" x="13.94" y="0">-</tspan>
                      <tspan class="cls-29" x="17.56" y="0">2</tspan>
                      <tspan x="21.35" y="0">0</tspan>
                    </text>
                    <text class="cls-25" transform="translate(104.56 278.67)">
                      <tspan class="cls-29">51s</tspan>
                      <tspan class="cls-28" x="9.62" y="0">q</tspan>
                      <tspan x="14.1" y="0">m</tspan>
                    </text>
                    <rect
                      class="cls-13"
                      x="99.59"
                      y="214.56"
                      width="30.83"
                      height="35.32"
                    />
                    <text class="cls-25" transform="translate(111.21 226.55)">
                      <tspan class="cls-26">B</tspan>
                      <tspan x="4.05" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(102.33 234.5)">
                      <tspan class="cls-26">#05</tspan>
                      <tspan class="cls-28" x="13.93" y="0">-</tspan>
                      <tspan class="cls-29" x="17.55" y="0">2</tspan>
                      <tspan x="21.34" y="0">0</tspan>
                    </text>
                    <text class="cls-25" transform="translate(104.56 242.46)">
                      <tspan class="cls-29">51sq</tspan>
                      <tspan x="14.11" y="0">m</tspan>
                    </text>
                  </g>
                  <g id="C2" @click="setunitimg('C2')">
                    <rect
                      class="cls-9"
                      x="163.8"
                      y="360.96"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-9"
                      x="163.8"
                      y="214.56"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-9"
                      x="163.8"
                      y="251.16"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-9"
                      x="163.8"
                      y="287.76"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-9"
                      x="163.8"
                      y="324.36"
                      width="30.83"
                      height="35.32"
                    />
                    <text class="cls-25" transform="translate(174.19 372.92)">
                      <tspan class="cls-29">C</tspan>
                      <tspan x="5.15" y="0">2</tspan>
                    </text>
                    <text class="cls-25" transform="translate(167.68 380.87)">
                      <tspan class="cls-26">#01</tspan>
                      <tspan class="cls-28" x="11.81" y="0">-</tspan>
                      <tspan class="cls-29" x="15.43" y="0">0</tspan>
                      <tspan x="19.59" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(167.67 388.83)">
                      <tspan class="cls-26">66sq</tspan>
                      <tspan x="16.33" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(174.18 262.77)">
                      <tspan class="cls-29">C</tspan>
                      <tspan x="5.15" y="0">2</tspan>
                    </text>
                    <text class="cls-25" transform="translate(166.88 270.72)">
                      <tspan class="cls-26">#04-1</tspan>
                      <tspan x="19.6" y="0">8</tspan>
                    </text>
                    <text class="cls-25" transform="translate(167.67 278.68)">
                      <tspan class="cls-26">66sq</tspan>
                      <tspan x="16.33" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(174.18 298.74)">
                      <tspan class="cls-29">C</tspan>
                      <tspan x="5.15" y="0">2</tspan>
                    </text>
                    <text class="cls-25" transform="translate(167.05 306.69)">
                      <tspan class="cls-26">#03</tspan>
                      <tspan class="cls-28" x="13.66" y="0">-</tspan>
                      <tspan class="cls-29" x="17.28" y="0">1</tspan>
                      <tspan x="19.32" y="0">8</tspan>
                    </text>
                    <text class="cls-25" transform="translate(167.67 314.65)">
                      <tspan class="cls-26">66sq</tspan>
                      <tspan x="16.33" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(174.18 335.67)">
                      <tspan class="cls-29">C</tspan>
                      <tspan x="5.15" y="0">2</tspan>
                    </text>
                    <text class="cls-25" transform="translate(167.1 343.62)">
                      <tspan class="cls-26">#02-1</tspan>
                      <tspan x="19.23" y="0">8</tspan>
                    </text>
                    <text class="cls-25" transform="translate(167.67 351.58)">
                      <tspan class="cls-26">66sq</tspan>
                      <tspan x="16.33" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(174.18 226.55)">
                      <tspan class="cls-29">C</tspan>
                      <tspan x="5.15" y="0">2</tspan>
                    </text>
                    <text class="cls-25" transform="translate(167.01 234.51)">
                      <tspan class="cls-26">#05-1</tspan>
                      <tspan x="19.6" y="0">8</tspan>
                    </text>
                    <text class="cls-25" transform="translate(167.67 242.47)">
                      <tspan class="cls-26">66sq</tspan>
                      <tspan x="16.33" y="0">m</tspan>
                    </text>
                  </g>
                  <g id="F1" @click="setunitimg('F1')">
                    <rect
                      class="cls-15"
                      x="228"
                      y="104.77"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-15"
                      x="228"
                      y="141.37"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-15"
                      x="228"
                      y="177.97"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-15"
                      x="228"
                      y="214.56"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-15"
                      x="228"
                      y="251.16"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-15"
                      x="228"
                      y="287.76"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-15"
                      x="228"
                      y="324.36"
                      width="30.83"
                      height="35.32"
                    />
                    <text class="cls-25" transform="translate(240.54 116.6)">
                      <tspan class="cls-29">F</tspan>
                      <tspan x="3.3" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(232.16 124.56)">
                      <tspan class="cls-26">#08-1</tspan>
                      <tspan x="19.62" y="0">6</tspan>
                    </text>
                    <text class="cls-25" transform="translate(232.84 132.51)">
                      <tspan class="cls-26">89sq</tspan>
                      <tspan x="16.26" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(240.55 152.82)">
                      <tspan class="cls-29">F</tspan>
                      <tspan x="3.3" y="0">1</tspan>
                    </text>
                    <text class="cls-30" transform="translate(232.55 160.78)">
                      #07-1
                      <tspan class="cls-32" x="19.03" y="0">6</tspan>
                    </text>
                    <text class="cls-25" transform="translate(232.85 168.73)">
                      <tspan class="cls-26">89sq</tspan>
                      <tspan x="16.26" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(240.57 190.05)">
                      <tspan class="cls-29">F</tspan>
                      <tspan x="3.3" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(232.22 198.01)">
                      <tspan class="cls-26">#06-1</tspan>
                      <tspan x="19.64" y="0">6</tspan>
                    </text>
                    <text class="cls-25" transform="translate(232.87 205.96)">
                      <tspan class="cls-26">89sq</tspan>
                      <tspan x="16.26" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(240.55 226.56)">
                      <tspan class="cls-29">F</tspan>
                      <tspan x="3.3" y="0">1</tspan>
                    </text>
                    <text class="cls-30" transform="translate(232.25 234.52)">
                      #05-1
                      <tspan class="cls-32" x="19.6" y="0">6</tspan>
                    </text>
                    <text class="cls-25" transform="translate(232.85 242.47)">
                      <tspan class="cls-26">89sq</tspan>
                      <tspan x="16.26" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(240.56 262.95)">
                      <tspan class="cls-29">F</tspan>
                      <tspan x="3.3" y="0">1</tspan>
                    </text>
                    <text class="cls-30" transform="translate(232.14 270.91)">
                      #04-1
                      <tspan class="cls-32" x="19.6" y="0">6</tspan>
                    </text>
                    <text class="cls-25" transform="translate(232.86 278.87)">
                      <tspan class="cls-26">89sq</tspan>
                      <tspan x="16.26" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(240.56 299.01)">
                      <tspan class="cls-29">F</tspan>
                      <tspan x="3.3" y="0">1</tspan>
                    </text>
                    <text class="cls-30" transform="translate(232.31 306.97)">
                      #03
                      <tspan class="cls-28" x="13.66" y="0">-</tspan>
                      <tspan class="cls-29" x="17.28" y="0">1</tspan>
                      <tspan class="cls-32" x="19.32" y="0">6</tspan>
                    </text>
                    <text class="cls-25" transform="translate(232.86 314.93)">
                      <tspan class="cls-26">89sq</tspan>
                      <tspan x="16.26" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(240.58 336.03)">
                      <tspan class="cls-29">F</tspan>
                      <tspan x="3.3" y="0">1</tspan>
                    </text>
                    <text class="cls-30" transform="translate(232.37 343.99)">
                      #02-1
                      <tspan class="cls-32" x="19.23" y="0">6</tspan>
                    </text>
                    <text class="cls-25" transform="translate(232.87 351.95)">
                      <tspan class="cls-26">89sq</tspan>
                      <tspan x="16.26" y="0">m</tspan>
                    </text>
                  </g>
                  <g id="F2" @click="setunitimg('F2')">
                    <rect
                      class="cls-15"
                      x="260.11"
                      y="104.77"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-15"
                      x="260.11"
                      y="141.37"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-15"
                      x="260.11"
                      y="177.97"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-15"
                      x="260.11"
                      y="214.56"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-15"
                      x="260.11"
                      y="251.16"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-15"
                      x="260.11"
                      y="287.76"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-15"
                      x="260.11"
                      y="324.36"
                      width="30.83"
                      height="35.32"
                    />
                    <text class="cls-25" transform="translate(271.41 116.61)">
                      <tspan class="cls-29">F</tspan>
                      <tspan x="3.3" y="0">2</tspan>
                    </text>
                    <text class="cls-30" transform="translate(263.73 124.56)">
                      #08-1
                      <tspan class="cls-31" x="19.62" y="0">5</tspan>
                    </text>
                    <text class="cls-25" transform="translate(265.18 132.52)">
                      <tspan class="cls-26">91sq</tspan>
                      <tspan x="14.12" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(271.42 152.83)">
                      <tspan class="cls-29">F</tspan>
                      <tspan x="3.3" y="0">2</tspan>
                    </text>
                    <text class="cls-25" transform="translate(264.11 160.78)">
                      <tspan class="cls-26">#07-1</tspan>
                      <tspan x="19.03" y="0">5</tspan>
                    </text>
                    <text class="cls-25" transform="translate(265.19 168.74)">
                      <tspan class="cls-26">91sq</tspan>
                      <tspan x="14.12" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(271.44 190.06)">
                      <tspan class="cls-29">F</tspan>
                      <tspan x="3.3" y="0">2</tspan>
                    </text>
                    <text class="cls-25" transform="translate(263.79 198.01)">
                      <tspan class="cls-26">#0</tspan>
                      <tspan class="cls-28" x="9.77" y="0">6</tspan>
                      <tspan class="cls-26" x="13.97" y="0">-1</tspan>
                      <tspan x="19.64" y="0">5</tspan>
                    </text>
                    <text class="cls-25" transform="translate(265.21 205.97)">
                      <tspan class="cls-26">91sq</tspan>
                      <tspan x="14.12" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(271.41 226.57)">
                      <tspan class="cls-29">F</tspan>
                      <tspan x="3.3" y="0">2</tspan>
                    </text>
                    <text class="cls-25" transform="translate(263.83 234.52)">
                      <tspan class="cls-26">#05-1</tspan>
                      <tspan x="19.6" y="0">5</tspan>
                    </text>
                    <text class="cls-25" transform="translate(265.19 242.48)">
                      <tspan class="cls-26">91sq</tspan>
                      <tspan x="14.12" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(271.43 262.96)">
                      <tspan class="cls-29">F</tspan>
                      <tspan x="3.3" y="0">2</tspan>
                    </text>
                    <text class="cls-25" transform="translate(263.71 270.92)">
                      <tspan class="cls-26">#04-1</tspan>
                      <tspan x="19.6" y="0">5</tspan>
                    </text>
                    <text class="cls-25" transform="translate(265.2 278.87)">
                      <tspan class="cls-26">91sq</tspan>
                      <tspan x="14.12" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(271.43 299.02)">
                      <tspan class="cls-29">F</tspan>
                      <tspan x="3.3" y="0">2</tspan>
                    </text>
                    <text class="cls-25" transform="translate(263.88 306.98)">
                      <tspan class="cls-26">#03-1</tspan>
                      <tspan x="19.33" y="0">5</tspan>
                    </text>
                    <text class="cls-25" transform="translate(265.2 314.93)">
                      <tspan class="cls-26">91sq</tspan>
                      <tspan x="14.12" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(271.43 336.04)">
                      <tspan class="cls-29">F</tspan>
                      <tspan x="3.3" y="0">2</tspan>
                    </text>
                    <text class="cls-25" transform="translate(263.94 344)">
                      <tspan class="cls-26">#02-1</tspan>
                      <tspan x="19.23" y="0">5</tspan>
                    </text>
                    <text class="cls-25" transform="translate(265.21 351.95)">
                      <tspan class="cls-26">91sq</tspan>
                      <tspan x="14.12" y="0">m</tspan>
                    </text>
                  </g>
                  <g id="C1" @click="setunitimg('C1')">
                    <rect
                      class="cls-9"
                      x="292.21"
                      y="104.77"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-9"
                      x="324.32"
                      y="104.77"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-9"
                      x="356.42"
                      y="104.77"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-9"
                      x="388.53"
                      y="104.77"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-9"
                      x="420.64"
                      y="104.77"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-9"
                      x="452.74"
                      y="104.77"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-9"
                      x="292.21"
                      y="141.37"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-9"
                      x="324.32"
                      y="141.37"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-9"
                      x="356.42"
                      y="141.37"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-9"
                      x="388.53"
                      y="141.37"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-9"
                      x="420.64"
                      y="141.37"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-9"
                      x="452.74"
                      y="141.37"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-9"
                      x="292.21"
                      y="177.97"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-9"
                      x="324.32"
                      y="177.97"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-9"
                      x="356.42"
                      y="177.97"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-9"
                      x="388.53"
                      y="177.97"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-9"
                      x="420.64"
                      y="177.97"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-9"
                      x="452.74"
                      y="177.97"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-9"
                      x="292.21"
                      y="214.56"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-9"
                      x="324.32"
                      y="214.56"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-9"
                      x="356.42"
                      y="214.56"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-9"
                      x="388.53"
                      y="214.56"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-9"
                      x="420.64"
                      y="214.56"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-9"
                      x="452.74"
                      y="214.56"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-9"
                      x="292.21"
                      y="251.16"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-9"
                      x="324.32"
                      y="251.16"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-9"
                      x="356.42"
                      y="251.16"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-9"
                      x="388.53"
                      y="251.16"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-9"
                      x="420.64"
                      y="251.16"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-9"
                      x="452.74"
                      y="251.16"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-9"
                      x="292.21"
                      y="287.76"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-9"
                      x="324.32"
                      y="287.76"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-9"
                      x="356.42"
                      y="287.76"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-9"
                      x="388.53"
                      y="287.76"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-9"
                      x="420.64"
                      y="287.76"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-9"
                      x="452.74"
                      y="287.76"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-9"
                      x="292.21"
                      y="324.36"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-9"
                      x="324.32"
                      y="324.36"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-9"
                      x="356.42"
                      y="324.36"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-9"
                      x="388.53"
                      y="324.36"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-9"
                      x="420.64"
                      y="324.36"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-9"
                      x="452.74"
                      y="324.36"
                      width="30.83"
                      height="35.32"
                    />
                    <text class="cls-25" transform="translate(303.26 116.61)">
                      <tspan class="cls-29">C</tspan>
                      <tspan x="5.15" y="0">1</tspan>
                    </text>
                    <text class="cls-30" transform="translate(295.31 124.57)">
                      #08-1
                      <tspan class="cls-31" x="19.62" y="0">4</tspan>
                    </text>
                    <text class="cls-25" transform="translate(296.1 132.53)">
                      <tspan class="cls-28">6</tspan>
                      <tspan class="cls-26" x="4.2" y="0">6s</tspan>
                      <tspan class="cls-28" x="11.83" y="0">q</tspan>
                      <tspan x="16.31" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(335.85 116.62)">
                      <tspan class="cls-29">C</tspan>
                      <tspan x="5.15" y="0">1</tspan>
                    </text>
                    <text class="cls-30" transform="translate(328.07 124.58)">
                      #08-1
                      <tspan class="cls-31" x="19.62" y="0">3</tspan>
                    </text>
                    <text class="cls-25" transform="translate(328.68 132.53)">
                      <tspan class="cls-28">6</tspan>
                      <tspan class="cls-26" x="4.2" y="0">6s</tspan>
                      <tspan class="cls-28" x="11.83" y="0">q</tspan>
                      <tspan x="16.31" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(367.68 116.63)">
                      <tspan class="cls-29">C</tspan>
                      <tspan x="5.15" y="0">1</tspan>
                    </text>
                    <text class="cls-30" transform="translate(359.94 124.58)">
                      #08-1
                      <tspan class="cls-31" x="19.62" y="0">2</tspan>
                    </text>
                    <text class="cls-25" transform="translate(360.51 132.54)">
                      <tspan class="cls-28">6</tspan>
                      <tspan class="cls-26" x="4.2" y="0">6s</tspan>
                      <tspan class="cls-28" x="11.83" y="0">q</tspan>
                      <tspan x="16.31" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(400.01 116.63)">
                      <tspan class="cls-29">C</tspan>
                      <tspan x="5.15" y="0">1</tspan>
                    </text>
                    <text class="cls-30" transform="translate(392.93 124.59)">
                      #08-1
                      <tspan class="cls-31" x="19.62" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(392.85 132.55)">
                      <tspan class="cls-28">6</tspan>
                      <tspan class="cls-26" x="4.2" y="0">6s</tspan>
                      <tspan class="cls-28" x="11.83" y="0">q</tspan>
                      <tspan x="16.31" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(432.35 116.64)">
                      <tspan class="cls-29">C</tspan>
                      <tspan x="5.15" y="0">1</tspan>
                    </text>
                    <text class="cls-30" transform="translate(424.36 124.6)">
                      #08-1
                      <tspan class="cls-31" x="19.62" y="0">0</tspan>
                    </text>
                    <text class="cls-25" transform="translate(425.18 132.55)">
                      <tspan class="cls-28">6</tspan>
                      <tspan class="cls-26" x="4.2" y="0">6s</tspan>
                      <tspan class="cls-28" x="11.83" y="0">q</tspan>
                      <tspan x="16.31" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(463.66 116.65)">
                      <tspan class="cls-29">C</tspan>
                      <tspan x="5.15" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(454.88 124.6)">
                      <tspan class="cls-26">#08-0</tspan>
                      <tspan x="21.74" y="0">9</tspan>
                    </text>
                    <text class="cls-25" transform="translate(456.51 132.56)">
                      <tspan class="cls-28">6</tspan>
                      <tspan class="cls-26" x="4.2" y="0">6s</tspan>
                      <tspan class="cls-28" x="11.83" y="0">q</tspan>
                      <tspan x="16.31" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(303.26 152.83)">
                      <tspan class="cls-29">C</tspan>
                      <tspan x="5.15" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(295.69 160.79)">
                      <tspan class="cls-26">#07-1</tspan>
                      <tspan x="19.03" y="0">4</tspan>
                    </text>
                    <text class="cls-25" transform="translate(296.1 168.75)">
                      <tspan class="cls-28">6</tspan>
                      <tspan class="cls-26" x="4.2" y="0">6s</tspan>
                      <tspan class="cls-28" x="11.83" y="0">q</tspan>
                      <tspan x="16.31" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(335.85 152.84)">
                      <tspan class="cls-29">C</tspan>
                      <tspan x="5.15" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(328.44 160.8)">
                      <tspan class="cls-26">#07-1</tspan>
                      <tspan x="19.03" y="0">3</tspan>
                    </text>
                    <text class="cls-25" transform="translate(328.69 168.75)">
                      <tspan class="cls-28">6</tspan>
                      <tspan class="cls-26" x="4.2" y="0">6s</tspan>
                      <tspan class="cls-28" x="11.83" y="0">q</tspan>
                      <tspan x="16.31" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(367.68 152.85)">
                      <tspan class="cls-29">C</tspan>
                      <tspan x="5.15" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(360.33 160.8)">
                      <tspan class="cls-26">#07-1</tspan>
                      <tspan x="19.03" y="0">2</tspan>
                    </text>
                    <text class="cls-25" transform="translate(360.53 168.76)">
                      <tspan class="cls-28">6</tspan>
                      <tspan class="cls-26" x="4.2" y="0">6s</tspan>
                      <tspan class="cls-28" x="11.83" y="0">q</tspan>
                      <tspan x="16.31" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(400.02 152.85)">
                      <tspan class="cls-29">C</tspan>
                      <tspan x="5.15" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(393.31 160.81)">
                      <tspan class="cls-26">#07-1</tspan>
                      <tspan x="19.03" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(392.86 168.77)">
                      <tspan class="cls-28">6</tspan>
                      <tspan class="cls-26" x="4.2" y="0">6s</tspan>
                      <tspan class="cls-28" x="11.83" y="0">q</tspan>
                      <tspan x="16.31" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(432.35 152.86)">
                      <tspan class="cls-29">C</tspan>
                      <tspan x="5.15" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(424.75 160.82)">
                      <tspan class="cls-26">#07-1</tspan>
                      <tspan x="19.03" y="0">0</tspan>
                    </text>
                    <text class="cls-25" transform="translate(425.19 168.77)">
                      <tspan class="cls-28">6</tspan>
                      <tspan class="cls-26" x="4.2" y="0">6s</tspan>
                      <tspan class="cls-28" x="11.83" y="0">q</tspan>
                      <tspan x="16.31" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(463.68 152.87)">
                      <tspan class="cls-29">C</tspan>
                      <tspan x="5.15" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(455.27 160.82)">
                      <tspan class="cls-26">#07-0</tspan>
                      <tspan x="21.15" y="0">9</tspan>
                    </text>
                    <text class="cls-25" transform="translate(456.51 168.78)">
                      <tspan class="cls-28">6</tspan>
                      <tspan class="cls-26" x="4.2" y="0">6s</tspan>
                      <tspan class="cls-28" x="11.83" y="0">q</tspan>
                      <tspan x="16.31" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(303.29 190.06)">
                      <tspan class="cls-29">C</tspan>
                      <tspan x="5.15" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(295.37 198.02)">
                      <tspan class="cls-26">#0</tspan>
                      <tspan class="cls-28" x="9.77" y="0">6</tspan>
                      <tspan class="cls-26" x="13.97" y="0">-1</tspan>
                      <tspan x="19.64" y="0">4</tspan>
                    </text>
                    <text class="cls-25" transform="translate(296.13 205.98)">
                      <tspan class="cls-28">6</tspan>
                      <tspan class="cls-26" x="4.2" y="0">6s</tspan>
                      <tspan class="cls-28" x="11.83" y="0">q</tspan>
                      <tspan x="16.31" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(335.88 190.07)">
                      <tspan class="cls-29">C</tspan>
                      <tspan x="5.15" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(328.13 198.03)">
                      <tspan class="cls-26">#0</tspan>
                      <tspan class="cls-28" x="9.77" y="0">6</tspan>
                      <tspan class="cls-26" x="13.97" y="0">-1</tspan>
                      <tspan x="19.64" y="0">3</tspan>
                    </text>
                    <text class="cls-25" transform="translate(328.71 205.99)">
                      <tspan class="cls-28">6</tspan>
                      <tspan class="cls-26" x="4.2" y="0">6s</tspan>
                      <tspan class="cls-28" x="11.83" y="0">q</tspan>
                      <tspan x="16.31" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(367.71 190.08)">
                      <tspan class="cls-29">C</tspan>
                      <tspan x="5.15" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(360 198.04)">
                      <tspan class="cls-26">#0</tspan>
                      <tspan class="cls-28" x="9.77" y="0">6</tspan>
                      <tspan class="cls-26" x="13.97" y="0">-1</tspan>
                      <tspan x="19.64" y="0">2</tspan>
                    </text>
                    <text class="cls-25" transform="translate(360.54 205.99)">
                      <tspan class="cls-28">6</tspan>
                      <tspan class="cls-26" x="4.2" y="0">6s</tspan>
                      <tspan class="cls-28" x="11.83" y="0">q</tspan>
                      <tspan x="16.31" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(400.04 190.09)">
                      <tspan class="cls-29">C</tspan>
                      <tspan x="5.15" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(392.99 198.04)">
                      <tspan class="cls-26">#0</tspan>
                      <tspan class="cls-28" x="9.77" y="0">6</tspan>
                      <tspan class="cls-26" x="13.97" y="0">-1</tspan>
                      <tspan x="19.64" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(392.88 206)">
                      <tspan class="cls-28">6</tspan>
                      <tspan class="cls-26" x="4.2" y="0">6s</tspan>
                      <tspan class="cls-28" x="11.83" y="0">q</tspan>
                      <tspan x="16.31" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(432.37 190.09)">
                      <tspan class="cls-29">C</tspan>
                      <tspan x="5.15" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(424.42 198.05)">
                      <tspan class="cls-26">#0</tspan>
                      <tspan class="cls-28" x="9.77" y="0">6</tspan>
                      <tspan class="cls-26" x="13.97" y="0">-1</tspan>
                      <tspan x="19.64" y="0">0</tspan>
                    </text>
                    <text class="cls-25" transform="translate(425.21 206.01)">
                      <tspan class="cls-28">6</tspan>
                      <tspan class="cls-26" x="4.2" y="0">6s</tspan>
                      <tspan class="cls-28" x="11.83" y="0">q</tspan>
                      <tspan x="16.31" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(463.69 190.1)">
                      <tspan class="cls-29">C</tspan>
                      <tspan x="5.15" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(454.94 198.06)">
                      <tspan class="cls-26">#0</tspan>
                      <tspan class="cls-28" x="9.77" y="0">6</tspan>
                      <tspan class="cls-26" x="13.97" y="0">-0</tspan>
                      <tspan x="21.76" y="0">9</tspan>
                    </text>
                    <text class="cls-25" transform="translate(456.53 206.01)">
                      <tspan class="cls-28">6</tspan>
                      <tspan class="cls-26" x="4.2" y="0">6s</tspan>
                      <tspan class="cls-28" x="11.83" y="0">q</tspan>
                      <tspan x="16.31" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(303.27 226.57)">
                      <tspan class="cls-29">C</tspan>
                      <tspan x="5.15" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(295.41 234.53)">
                      <tspan class="cls-26">#05-1</tspan>
                      <tspan x="19.6" y="0">4</tspan>
                    </text>
                    <text class="cls-25" transform="translate(296.11 242.49)">
                      <tspan class="cls-28">6</tspan>
                      <tspan class="cls-26" x="4.2" y="0">6s</tspan>
                      <tspan class="cls-28" x="11.83" y="0">q</tspan>
                      <tspan x="16.31" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(335.86 226.58)">
                      <tspan class="cls-29">C</tspan>
                      <tspan x="5.15" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(328.17 234.54)">
                      <tspan class="cls-26">#05-1</tspan>
                      <tspan x="19.6" y="0">3</tspan>
                    </text>
                    <text class="cls-25" transform="translate(328.69 242.5)">
                      <tspan class="cls-28">6</tspan>
                      <tspan class="cls-26" x="4.2" y="0">6s</tspan>
                      <tspan class="cls-28" x="11.83" y="0">q</tspan>
                      <tspan x="16.31" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(367.69 226.59)">
                      <tspan class="cls-29">C</tspan>
                      <tspan x="5.15" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(360.04 234.55)">
                      <tspan class="cls-26">#05-1</tspan>
                      <tspan x="19.6" y="0">2</tspan>
                    </text>
                    <text class="cls-25" transform="translate(360.52 242.5)">
                      <tspan class="cls-28">6</tspan>
                      <tspan class="cls-26" x="4.2" y="0">6s</tspan>
                      <tspan class="cls-28" x="11.83" y="0">q</tspan>
                      <tspan x="16.31" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(400.02 226.6)">
                      <tspan class="cls-29">C</tspan>
                      <tspan x="5.15" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(393.03 234.55)">
                      <tspan class="cls-26">#05-1</tspan>
                      <tspan x="19.6" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(392.86 242.51)">
                      <tspan class="cls-28">6</tspan>
                      <tspan class="cls-26" x="4.2" y="0">6s</tspan>
                      <tspan class="cls-28" x="11.83" y="0">q</tspan>
                      <tspan x="16.31" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(432.36 226.6)">
                      <tspan class="cls-29">C</tspan>
                      <tspan x="5.15" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(424.46 234.56)">
                      <tspan class="cls-26">#05-1</tspan>
                      <tspan x="19.6" y="0">0</tspan>
                    </text>
                    <text class="cls-25" transform="translate(425.19 242.52)">
                      <tspan class="cls-28">6</tspan>
                      <tspan class="cls-26" x="4.2" y="0">6s</tspan>
                      <tspan class="cls-28" x="11.83" y="0">q</tspan>
                      <tspan x="16.31" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(463.67 226.61)">
                      <tspan class="cls-29">C</tspan>
                      <tspan x="5.15" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(454.98 234.57)">
                      <tspan class="cls-26">#05-0</tspan>
                      <tspan x="21.72" y="0">9</tspan>
                    </text>
                    <text class="cls-25" transform="translate(456.52 242.52)">
                      <tspan class="cls-28">6</tspan>
                      <tspan class="cls-26" x="4.2" y="0">6s</tspan>
                      <tspan class="cls-28" x="11.83" y="0">q</tspan>
                      <tspan x="16.31" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(303.27 262.97)">
                      <tspan class="cls-29">C</tspan>
                      <tspan x="5.15" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(295.28 270.92)">
                      <tspan class="cls-26">#04-1</tspan>
                      <tspan x="19.6" y="0">4</tspan>
                    </text>
                    <text class="cls-25" transform="translate(296.11 278.88)">
                      <tspan class="cls-28">6</tspan>
                      <tspan class="cls-26" x="4.2" y="0">6s</tspan>
                      <tspan class="cls-28" x="11.83" y="0">q</tspan>
                      <tspan x="16.31" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(335.86 262.97)">
                      <tspan class="cls-29">C</tspan>
                      <tspan x="5.15" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(328.04 270.93)">
                      <tspan class="cls-26">#04-1</tspan>
                      <tspan x="19.6" y="0">3</tspan>
                    </text>
                    <text class="cls-25" transform="translate(328.7 278.89)">
                      <tspan class="cls-28">6</tspan>
                      <tspan class="cls-26" x="4.2" y="0">6s</tspan>
                      <tspan class="cls-28" x="11.83" y="0">q</tspan>
                      <tspan x="16.31" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(367.7 262.98)">
                      <tspan class="cls-29">C</tspan>
                      <tspan x="5.15" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(359.92 270.94)">
                      <tspan class="cls-26">#04-1</tspan>
                      <tspan x="19.6" y="0">2</tspan>
                    </text>
                    <text class="cls-25" transform="translate(360.54 278.89)">
                      <tspan class="cls-28">6</tspan>
                      <tspan class="cls-26" x="4.2" y="0">6s</tspan>
                      <tspan class="cls-28" x="11.83" y="0">q</tspan>
                      <tspan x="16.31" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(400.03 262.99)">
                      <tspan class="cls-29">C</tspan>
                      <tspan x="5.15" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(392.91 270.94)">
                      <tspan class="cls-26">#04-1</tspan>
                      <tspan x="19.6" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(392.87 278.9)">
                      <tspan class="cls-28">6</tspan>
                      <tspan class="cls-26" x="4.2" y="0">6s</tspan>
                      <tspan class="cls-28" x="11.83" y="0">q</tspan>
                      <tspan x="16.31" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(432.36 262.99)">
                      <tspan class="cls-29">C</tspan>
                      <tspan x="5.15" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(424.34 270.95)">
                      <tspan class="cls-26">#04-1</tspan>
                      <tspan x="19.6" y="0">0</tspan>
                    </text>
                    <text class="cls-25" transform="translate(425.2 278.91)">
                      <tspan class="cls-28">6</tspan>
                      <tspan class="cls-26" x="4.2" y="0">6s</tspan>
                      <tspan class="cls-28" x="11.83" y="0">q</tspan>
                      <tspan x="16.31" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(463.69 263)">
                      <tspan class="cls-29">C</tspan>
                      <tspan x="5.15" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(454.86 270.96)">
                      <tspan class="cls-26">#04-0</tspan>
                      <tspan x="21.72" y="0">9</tspan>
                    </text>
                    <text class="cls-25" transform="translate(456.52 278.91)">
                      <tspan class="cls-28">6</tspan>
                      <tspan class="cls-26" x="4.2" y="0">6s</tspan>
                      <tspan class="cls-28" x="11.83" y="0">q</tspan>
                      <tspan x="16.31" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(303.27 299.03)">
                      <tspan class="cls-29">C</tspan>
                      <tspan x="5.15" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(295.46 306.98)">
                      <tspan class="cls-26">#03-1</tspan>
                      <tspan x="19.33" y="0">4</tspan>
                    </text>
                    <text class="cls-25" transform="translate(296.12 314.94)">
                      <tspan class="cls-28">6</tspan>
                      <tspan class="cls-26" x="4.2" y="0">6s</tspan>
                      <tspan class="cls-28" x="11.83" y="0">q</tspan>
                      <tspan x="16.31" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(335.87 299.03)">
                      <tspan class="cls-29">C</tspan>
                      <tspan x="5.15" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(328.21 306.99)">
                      <tspan class="cls-26">#03-1</tspan>
                      <tspan x="19.33" y="0">3</tspan>
                    </text>
                    <text class="cls-25" transform="translate(328.7 314.95)">
                      <tspan class="cls-28">6</tspan>
                      <tspan class="cls-26" x="4.2" y="0">6s</tspan>
                      <tspan class="cls-28" x="11.83" y="0">q</tspan>
                      <tspan x="16.31" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(367.69 299.04)">
                      <tspan class="cls-29">C</tspan>
                      <tspan x="5.15" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(360.09 307)">
                      <tspan class="cls-26">#03-1</tspan>
                      <tspan x="19.33" y="0">2</tspan>
                    </text>
                    <text class="cls-25" transform="translate(360.53 314.96)">
                      <tspan class="cls-28">6</tspan>
                      <tspan class="cls-26" x="4.2" y="0">6s</tspan>
                      <tspan class="cls-28" x="11.83" y="0">q</tspan>
                      <tspan x="16.31" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(400.03 299.05)">
                      <tspan class="cls-29">C</tspan>
                      <tspan x="5.15" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(393.07 307.01)">
                      <tspan class="cls-26">#03-1</tspan>
                      <tspan x="19.33" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(392.87 314.96)">
                      <tspan class="cls-28">6</tspan>
                      <tspan class="cls-26" x="4.2" y="0">6s</tspan>
                      <tspan class="cls-28" x="11.83" y="0">q</tspan>
                      <tspan x="16.31" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(432.36 299.06)">
                      <tspan class="cls-29">C</tspan>
                      <tspan x="5.15" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(424.51 307.01)">
                      <tspan class="cls-26">#03-1</tspan>
                      <tspan x="19.33" y="0">0</tspan>
                    </text>
                    <text class="cls-25" transform="translate(425.2 314.97)">
                      <tspan class="cls-28">6</tspan>
                      <tspan class="cls-26" x="4.2" y="0">6s</tspan>
                      <tspan class="cls-28" x="11.83" y="0">q</tspan>
                      <tspan x="16.31" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(463.68 299.06)">
                      <tspan class="cls-29">C</tspan>
                      <tspan x="5.15" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(455.03 307.02)">
                      <tspan class="cls-26">#03-0</tspan>
                      <tspan x="21.45" y="0">9</tspan>
                    </text>
                    <text class="cls-25" transform="translate(456.52 314.98)">
                      <tspan class="cls-28">6</tspan>
                      <tspan class="cls-26" x="4.2" y="0">6s</tspan>
                      <tspan class="cls-28" x="11.83" y="0">q</tspan>
                      <tspan x="16.31" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(303.29 336.05)">
                      <tspan class="cls-29">C</tspan>
                      <tspan x="5.15" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(295.52 344)">
                      <tspan class="cls-26">#02-1</tspan>
                      <tspan x="19.23" y="0">4</tspan>
                    </text>
                    <text class="cls-25" transform="translate(296.13 351.96)">
                      <tspan class="cls-28">6</tspan>
                      <tspan class="cls-26" x="4.2" y="0">6s</tspan>
                      <tspan class="cls-28" x="11.83" y="0">q</tspan>
                      <tspan x="16.31" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(335.88 336.05)">
                      <tspan class="cls-29">C</tspan>
                      <tspan x="5.15" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(328.27 344.01)">
                      <tspan class="cls-26">#02-1</tspan>
                      <tspan x="19.23" y="0">3</tspan>
                    </text>
                    <text class="cls-25" transform="translate(328.71 351.97)">
                      <tspan class="cls-28">6</tspan>
                      <tspan class="cls-26" x="4.2" y="0">6s</tspan>
                      <tspan class="cls-28" x="11.83" y="0">q</tspan>
                      <tspan x="16.31" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(367.71 336.06)">
                      <tspan class="cls-29">C</tspan>
                      <tspan x="5.15" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(360.15 344.02)">
                      <tspan class="cls-26">#02-1</tspan>
                      <tspan x="19.23" y="0">2</tspan>
                    </text>
                    <text class="cls-25" transform="translate(360.54 351.97)">
                      <tspan class="cls-28">6</tspan>
                      <tspan class="cls-26" x="4.2" y="0">6s</tspan>
                      <tspan class="cls-28" x="11.83" y="0">q</tspan>
                      <tspan x="16.31" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(400.04 336.07)">
                      <tspan class="cls-29">C</tspan>
                      <tspan x="5.15" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(393.13 344.02)">
                      <tspan class="cls-26">#02-1</tspan>
                      <tspan x="19.23" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(392.88 351.98)">
                      <tspan class="cls-28">6</tspan>
                      <tspan class="cls-26" x="4.2" y="0">6s</tspan>
                      <tspan class="cls-28" x="11.83" y="0">q</tspan>
                      <tspan x="16.31" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(432.38 336.07)">
                      <tspan class="cls-29">C</tspan>
                      <tspan x="5.15" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(424.57 344.03)">
                      <tspan class="cls-26">#02-1</tspan>
                      <tspan x="19.23" y="0">0</tspan>
                    </text>
                    <text class="cls-25" transform="translate(425.21 351.99)">
                      <tspan class="cls-28">6</tspan>
                      <tspan class="cls-26" x="4.2" y="0">6s</tspan>
                      <tspan class="cls-28" x="11.83" y="0">q</tspan>
                      <tspan x="16.31" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(463.7 336.08)">
                      <tspan class="cls-29">C</tspan>
                      <tspan x="5.15" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(455.09 344.04)">
                      <tspan class="cls-26">#02-0</tspan>
                      <tspan x="21.35" y="0">9</tspan>
                    </text>
                    <text class="cls-25" transform="translate(456.54 351.99)">
                      <tspan class="cls-28">6</tspan>
                      <tspan class="cls-26" x="4.2" y="0">6s</tspan>
                      <tspan class="cls-28" x="11.83" y="0">q</tspan>
                      <tspan x="16.31" y="0">m</tspan>
                    </text>
                  </g>
                  <g id="F3" @click="setunitimg('F3')">
                    <rect
                      class="cls-15"
                      x="484.84"
                      y="104.77"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-15"
                      x="484.84"
                      y="141.37"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-15"
                      x="484.84"
                      y="177.97"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-15"
                      x="484.84"
                      y="214.56"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-15"
                      x="484.84"
                      y="251.16"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-15"
                      x="484.84"
                      y="287.76"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-15"
                      x="484.84"
                      y="324.36"
                      width="30.83"
                      height="35.32"
                    />
                    <text class="cls-25" transform="translate(496.19 116.65)">
                      <tspan class="cls-29">F</tspan>
                      <tspan x="3.3" y="0">3</tspan>
                    </text>
                    <text class="cls-25" transform="translate(487.57 124.61)">
                      <tspan class="cls-26">#08</tspan>
                      <tspan class="cls-28" x="13.95" y="0">-</tspan>
                      <tspan class="cls-29" x="17.57" y="0">0</tspan>
                      <tspan x="21.73" y="0">8</tspan>
                    </text>
                    <text class="cls-25" transform="translate(489.36 132.57)">
                      <tspan class="cls-26">92s</tspan>
                      <tspan class="cls-28" x="11.39" y="0">q</tspan>
                      <tspan x="15.87" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(496.19 152.87)">
                      <tspan class="cls-29">F</tspan>
                      <tspan x="3.3" y="0">3</tspan>
                    </text>
                    <text class="cls-25" transform="translate(487.96 160.83)">
                      <tspan class="cls-26">#07-0</tspan>
                      <tspan x="21.15" y="0">8</tspan>
                    </text>
                    <text class="cls-25" transform="translate(489.37 168.79)">
                      <tspan class="cls-26">92sq</tspan>
                      <tspan x="15.88" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(496.21 190.11)">
                      <tspan class="cls-29">F</tspan>
                      <tspan x="3.3" y="0">3</tspan>
                    </text>
                    <text class="cls-25" transform="translate(487.62 198.06)">
                      <tspan class="cls-26">#0</tspan>
                      <tspan class="cls-28" x="9.77" y="0">6</tspan>
                      <tspan class="cls-26" x="13.97" y="0">-0</tspan>
                      <tspan x="21.76" y="0">8</tspan>
                    </text>
                    <text class="cls-25" transform="translate(489.38 206.02)">
                      <tspan class="cls-26">92sq</tspan>
                      <tspan x="15.88" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(496.2 226.62)">
                      <tspan class="cls-29">F</tspan>
                      <tspan x="3.3" y="0">3</tspan>
                    </text>
                    <text class="cls-25" transform="translate(487.67 234.57)">
                      <tspan class="cls-26">#05-0</tspan>
                      <tspan x="21.72" y="0">8</tspan>
                    </text>
                    <text class="cls-25" transform="translate(489.37 242.53)">
                      <tspan class="cls-26">92s</tspan>
                      <tspan class="cls-28" x="11.39" y="0">q</tspan>
                      <tspan x="15.87" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(496.2 263.01)">
                      <tspan class="cls-29">F</tspan>
                      <tspan x="3.3" y="0">3</tspan>
                    </text>
                    <text class="cls-25" transform="translate(487.55 270.96)">
                      <tspan class="cls-26">#04-0</tspan>
                      <tspan x="21.72" y="0">8</tspan>
                    </text>
                    <text class="cls-25" transform="translate(489.38 278.92)">
                      <tspan class="cls-26">92sq</tspan>
                      <tspan x="15.88" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(496.2 299.07)">
                      <tspan class="cls-29">F</tspan>
                      <tspan x="3.3" y="0">3</tspan>
                    </text>
                    <text class="cls-25" transform="translate(487.72 307.03)">
                      <tspan class="cls-26">#03-0</tspan>
                      <tspan x="21.45" y="0">8</tspan>
                    </text>
                    <text class="cls-25" transform="translate(489.38 314.98)">
                      <tspan class="cls-26">92s</tspan>
                      <tspan class="cls-28" x="11.39" y="0">q</tspan>
                      <tspan x="15.87" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(496.22 336.09)">
                      <tspan class="cls-29">F</tspan>
                      <tspan x="3.3" y="0">3</tspan>
                    </text>
                    <text class="cls-25" transform="translate(487.78 344.04)">
                      <tspan class="cls-26">#02-0</tspan>
                      <tspan x="21.35" y="0">8</tspan>
                    </text>
                    <text class="cls-25" transform="translate(489.39 352)">
                      <tspan class="cls-26">92sq</tspan>
                      <tspan x="15.88" y="0">m</tspan>
                    </text>
                  </g>
                  <g id="G3" @click="setunitimg('G3')">
                    <rect
                      class="cls-11"
                      x="516.95"
                      y="104.77"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-11"
                      x="516.95"
                      y="141.37"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-11"
                      x="516.95"
                      y="177.97"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-11"
                      x="516.95"
                      y="214.56"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-11"
                      x="516.95"
                      y="251.16"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-11"
                      x="516.95"
                      y="287.76"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-11"
                      x="516.95"
                      y="324.36"
                      width="30.83"
                      height="35.32"
                    />
                    <text class="cls-25" transform="translate(527.48 116.66)">
                      <tspan class="cls-26">G</tspan>
                      <tspan x="5.19" y="0">3</tspan>
                    </text>
                    <text class="cls-25" transform="translate(519.78 124.62)">
                      <tspan class="cls-26">#08-0</tspan>
                      <tspan x="21.74" y="0">7</tspan>
                    </text>
                    <text class="cls-30" transform="translate(519.72 132.57)">
                      109sq
                      <tspan class="cls-31" x="18.28" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(527.49 152.88)">
                      <tspan class="cls-26">G</tspan>
                      <tspan x="5.19" y="0">3</tspan>
                    </text>
                    <text class="cls-25" transform="translate(520.16 160.84)">
                      <tspan class="cls-26">#0</tspan>
                      <tspan class="cls-28" x="9.77" y="0">7</tspan>
                      <tspan class="cls-26" x="13.36" y="0">-0</tspan>
                      <tspan x="21.15" y="0">7</tspan>
                    </text>
                    <text class="cls-30" transform="translate(519.74 168.8)">
                      109sq
                      <tspan class="cls-31" x="18.28" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(527.5 190.11)">
                      <tspan class="cls-26">G</tspan>
                      <tspan x="5.19" y="0">3</tspan>
                    </text>
                    <text class="cls-30" transform="translate(519.83 198.07)">
                      #0
                      <tspan class="cls-28" x="9.77" y="0">6</tspan>
                      <tspan x="13.97" y="0">-0</tspan>
                      <tspan class="cls-31" x="21.76" y="0">7</tspan>
                    </text>
                    <text class="cls-30" transform="translate(519.74 206.03)">
                      109sq
                      <tspan class="cls-31" x="18.28" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(527.49 226.62)">
                      <tspan class="cls-26">G</tspan>
                      <tspan x="5.19" y="0">3</tspan>
                    </text>
                    <text class="cls-25" transform="translate(519.88 234.58)">
                      <tspan class="cls-26">#05-0</tspan>
                      <tspan x="21.72" y="0">7</tspan>
                    </text>
                    <text class="cls-30" transform="translate(519.73 242.54)">
                      109sq
                      <tspan class="cls-31" x="18.28" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(527.5 263.02)">
                      <tspan class="cls-26">G</tspan>
                      <tspan x="5.19" y="0">3</tspan>
                    </text>
                    <text class="cls-25" transform="translate(519.75 270.97)">
                      <tspan class="cls-26">#04-0</tspan>
                      <tspan x="21.72" y="0">7</tspan>
                    </text>
                    <text class="cls-30" transform="translate(519.73 278.93)">
                      109sq
                      <tspan class="cls-31" x="18.28" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(527.5 299.08)">
                      <tspan class="cls-26">G</tspan>
                      <tspan x="5.19" y="0">3</tspan>
                    </text>
                    <text class="cls-25" transform="translate(519.92 307.03)">
                      <tspan class="cls-26">#0</tspan>
                      <tspan class="cls-28" x="9.77" y="0">3</tspan>
                      <tspan class="cls-26" x="13.66" y="0">-0</tspan>
                      <tspan x="21.44" y="0">7</tspan>
                    </text>
                    <text class="cls-30" transform="translate(519.74 314.99)">
                      109sq
                      <tspan class="cls-31" x="18.28" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(527.51 336.09)">
                      <tspan class="cls-26">G</tspan>
                      <tspan x="5.19" y="0">3</tspan>
                    </text>
                    <text class="cls-25" transform="translate(519.99 344.05)">
                      <tspan class="cls-26">#02-0</tspan>
                      <tspan x="21.35" y="0">7</tspan>
                    </text>
                    <text class="cls-30" transform="translate(519.75 352.01)">
                      109sq
                      <tspan class="cls-31" x="18.28" y="0">m</tspan>
                    </text>
                  </g>
                  <g id="A2" @click="setunitimg('A2')">
                    <rect
                      class="cls-8"
                      x="549.05"
                      y="104.77"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-8"
                      x="549.05"
                      y="141.37"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-8"
                      x="549.05"
                      y="177.97"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-8"
                      x="549.05"
                      y="214.56"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-8"
                      x="549.05"
                      y="251.16"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-8"
                      x="549.05"
                      y="287.76"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-8"
                      x="549.05"
                      y="324.36"
                      width="30.83"
                      height="35.32"
                    />
                    <text class="cls-25" transform="translate(560.02 116.67)">
                      <tspan class="cls-26">A</tspan>
                      <tspan x="4.47" y="0">2</tspan>
                    </text>
                    <text class="cls-30" transform="translate(551.89 124.62)">
                      #08-0
                      <tspan class="cls-32" x="21.74" y="0">6</tspan>
                    </text>
                    <text class="cls-30" transform="translate(553.44 132.58)">
                      4
                      <tspan class="cls-28" x="4.16" y="0">6</tspan>
                      <tspan x="8.36" y="0">s</tspan>
                      <tspan class="cls-28" x="11.79" y="0">q</tspan>
                      <tspan class="cls-31" x="16.27" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(560.03 152.89)">
                      <tspan class="cls-26">A</tspan>
                      <tspan x="4.47" y="0">2</tspan>
                    </text>
                    <text class="cls-25" transform="translate(552.28 160.85)">
                      <tspan class="cls-26">#0</tspan>
                      <tspan class="cls-28" x="9.77" y="0">7</tspan>
                      <tspan class="cls-26" x="13.36" y="0">-0</tspan>
                      <tspan x="21.15" y="0">6</tspan>
                    </text>
                    <text class="cls-30" transform="translate(553.45 168.8)">
                      4
                      <tspan class="cls-28" x="4.16" y="0">6</tspan>
                      <tspan x="8.36" y="0">s</tspan>
                      <tspan class="cls-28" x="11.79" y="0">q</tspan>
                      <tspan class="cls-31" x="16.27" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(560.04 190.12)">
                      <tspan class="cls-26">A</tspan>
                      <tspan x="4.47" y="0">2</tspan>
                    </text>
                    <text class="cls-25" transform="translate(551.95 198.08)">
                      <tspan class="cls-26">#0</tspan>
                      <tspan class="cls-28" x="9.77" y="0">6</tspan>
                      <tspan class="cls-26" x="13.97" y="0">-0</tspan>
                      <tspan x="21.76" y="0">6</tspan>
                    </text>
                    <text class="cls-30" transform="translate(553.46 206.03)">
                      4
                      <tspan class="cls-28" x="4.16" y="0">6</tspan>
                      <tspan x="8.36" y="0">sq</tspan>
                      <tspan class="cls-31" x="16.28" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(560.03 226.63)">
                      <tspan class="cls-26">A</tspan>
                      <tspan x="4.47" y="0">2</tspan>
                    </text>
                    <text class="cls-25" transform="translate(551.99 234.59)">
                      <tspan class="cls-26">#05-0</tspan>
                      <tspan x="21.72" y="0">6</tspan>
                    </text>
                    <text class="cls-30" transform="translate(553.45 242.54)">
                      4
                      <tspan class="cls-28" x="4.16" y="0">6</tspan>
                      <tspan x="8.36" y="0">sq</tspan>
                      <tspan class="cls-31" x="16.28" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(560.03 263.02)">
                      <tspan class="cls-26">A</tspan>
                      <tspan x="4.47" y="0">2</tspan>
                    </text>
                    <text class="cls-30" transform="translate(551.86 270.98)">
                      #04-0
                      <tspan class="cls-32" x="21.72" y="0">6</tspan>
                    </text>
                    <text class="cls-30" transform="translate(553.45 278.93)">
                      4
                      <tspan class="cls-28" x="4.16" y="0">6</tspan>
                      <tspan x="8.36" y="0">sq</tspan>
                      <tspan class="cls-31" x="16.28" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(560.03 299.08)">
                      <tspan class="cls-26">A</tspan>
                      <tspan x="4.47" y="0">2</tspan>
                    </text>
                    <text class="cls-30" transform="translate(552.04 307.04)">
                      #0
                      <tspan class="cls-28" x="9.77" y="0">3</tspan>
                      <tspan x="13.66" y="0">-0</tspan>
                      <tspan class="cls-32" x="21.44" y="0">6</tspan>
                    </text>
                    <text class="cls-30" transform="translate(553.46 315)">
                      4
                      <tspan class="cls-28" x="4.16" y="0">6</tspan>
                      <tspan x="8.36" y="0">s</tspan>
                      <tspan class="cls-28" x="11.79" y="0">q</tspan>
                      <tspan class="cls-31" x="16.27" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(560.05 336.1)">
                      <tspan class="cls-26">A</tspan>
                      <tspan x="4.47" y="0">2</tspan>
                    </text>
                    <text class="cls-25" transform="translate(552.1 344.06)">
                      <tspan class="cls-26">#02-0</tspan>
                      <tspan x="21.35" y="0">6</tspan>
                    </text>
                    <text class="cls-30" transform="translate(553.47 352.02)">
                      4
                      <tspan class="cls-28" x="4.16" y="0">6</tspan>
                      <tspan x="8.36" y="0">sq</tspan>
                      <tspan class="cls-31" x="16.28" y="0">m</tspan>
                    </text>
                  </g>
                  <g id="A1" @click="setunitimg('A1')">
                    <rect
                      class="cls-8"
                      x="581.16"
                      y="104.77"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-8"
                      x="581.16"
                      y="141.37"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-8"
                      x="581.16"
                      y="177.97"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-8"
                      x="581.16"
                      y="214.56"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-8"
                      x="581.16"
                      y="251.16"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-8"
                      x="581.16"
                      y="287.76"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-8"
                      x="581.16"
                      y="324.36"
                      width="30.83"
                      height="35.32"
                    />
                    <text class="cls-25" transform="translate(592.63 116.67)">
                      <tspan class="cls-26">A</tspan>
                      <tspan x="4.47" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(583.91 124.63)">
                      <tspan class="cls-26">#08-0</tspan>
                      <tspan x="21.74" y="0">5</tspan>
                    </text>
                    <text class="cls-25" transform="translate(585.46 132.59)">
                      <tspan class="cls-26">45sq</tspan>
                      <tspan x="16.24" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(592.64 152.89)">
                      <tspan class="cls-26">A</tspan>
                      <tspan x="4.47" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(584.29 160.85)">
                      <tspan class="cls-26">#0</tspan>
                      <tspan class="cls-28" x="9.77" y="0">7</tspan>
                      <tspan class="cls-26" x="13.36" y="0">-0</tspan>
                      <tspan x="21.15" y="0">5</tspan>
                    </text>
                    <text class="cls-25" transform="translate(585.46 168.81)">
                      <tspan class="cls-26">45sq</tspan>
                      <tspan x="16.24" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(592.65 190.13)">
                      <tspan class="cls-26">A</tspan>
                      <tspan x="4.47" y="0">1</tspan>
                    </text>
                    <text class="cls-30" transform="translate(583.96 198.08)">
                      #0
                      <tspan class="cls-28" x="9.77" y="0">6</tspan>
                      <tspan x="13.97" y="0">-0</tspan>
                      <tspan class="cls-31" x="21.76" y="0">5</tspan>
                    </text>
                    <text class="cls-25" transform="translate(585.48 206.04)">
                      <tspan class="cls-26">45sq</tspan>
                      <tspan x="16.24" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(592.63 226.64)">
                      <tspan class="cls-26">A</tspan>
                      <tspan x="4.47" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(584 234.59)">
                      <tspan class="cls-26">#05-0</tspan>
                      <tspan x="21.72" y="0">5</tspan>
                    </text>
                    <text class="cls-25" transform="translate(585.46 242.55)">
                      <tspan class="cls-26">45sq</tspan>
                      <tspan x="16.24" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(592.63 263.03)">
                      <tspan class="cls-26">A</tspan>
                      <tspan x="4.47" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(583.88 270.98)">
                      <tspan class="cls-26">#04-0</tspan>
                      <tspan x="21.72" y="0">5</tspan>
                    </text>
                    <text class="cls-25" transform="translate(585.46 278.94)">
                      <tspan class="cls-26">45sq</tspan>
                      <tspan x="16.24" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(592.65 299.09)">
                      <tspan class="cls-26">A</tspan>
                      <tspan x="4.47" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(584.06 307.05)">
                      <tspan class="cls-26">#0</tspan>
                      <tspan class="cls-28" x="9.77" y="0">3</tspan>
                      <tspan class="cls-26" x="13.66" y="0">-0</tspan>
                      <tspan x="21.44" y="0">5</tspan>
                    </text>
                    <text class="cls-25" transform="translate(585.47 315)">
                      <tspan class="cls-26">45sq</tspan>
                      <tspan x="16.24" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(592.65 336.11)">
                      <tspan class="cls-26">A</tspan>
                      <tspan x="4.47" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(584.11 344.06)">
                      <tspan class="cls-26">#02-0</tspan>
                      <tspan x="21.35" y="0">5</tspan>
                    </text>
                    <text class="cls-25" transform="translate(585.47 352.02)">
                      <tspan class="cls-26">45sq</tspan>
                      <tspan x="16.24" y="0">m</tspan>
                    </text>
                  </g>
                  <g id="C3" @click="setunitimg('C3')">
                    <rect
                      class="cls-9"
                      x="613.27"
                      y="104.77"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-9"
                      x="645.37"
                      y="104.77"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-9"
                      x="613.27"
                      y="141.37"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-9"
                      x="645.37"
                      y="141.37"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-9"
                      x="613.27"
                      y="177.97"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-9"
                      x="645.37"
                      y="177.97"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-9"
                      x="613.27"
                      y="214.56"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-9"
                      x="645.37"
                      y="214.56"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-9"
                      x="613.27"
                      y="251.16"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-9"
                      x="645.37"
                      y="251.16"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-9"
                      x="613.27"
                      y="287.76"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-9"
                      x="645.37"
                      y="287.76"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-9"
                      x="613.27"
                      y="324.36"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-9"
                      x="645.37"
                      y="324.36"
                      width="30.83"
                      height="35.32"
                    />
                    <text class="cls-25" transform="translate(624.27 116.68)">
                      <tspan class="cls-29">C</tspan>
                      <tspan x="5.15" y="0">3</tspan>
                    </text>
                    <text class="cls-25" transform="translate(616.11 124.64)">
                      <tspan class="cls-26">#08-0</tspan>
                      <tspan x="21.74" y="0">4</tspan>
                    </text>
                    <text class="cls-25" transform="translate(618.15 132.6)">
                      <tspan class="cls-26">6</tspan>
                      <tspan class="cls-27" x="4.21" y="0">7</tspan>
                      <tspan class="cls-26" x="7.79" y="0">s</tspan>
                      <tspan class="cls-28" x="11.22" y="0">q</tspan>
                      <tspan x="15.7" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(655.71 116.69)">
                      <tspan class="cls-29">C</tspan>
                      <tspan x="5.15" y="0">3</tspan>
                    </text>
                    <text class="cls-25" transform="translate(647.73 124.65)">
                      <tspan class="cls-26">#08-0</tspan>
                      <tspan x="21.74" y="0">3</tspan>
                    </text>
                    <text class="cls-25" transform="translate(649.59 132.6)">
                      <tspan class="cls-26">6</tspan>
                      <tspan class="cls-27" x="4.21" y="0">7</tspan>
                      <tspan class="cls-26" x="7.79" y="0">s</tspan>
                      <tspan class="cls-28" x="11.22" y="0">q</tspan>
                      <tspan x="15.7" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(624.28 152.9)">
                      <tspan class="cls-29">C</tspan>
                      <tspan x="5.15" y="0">3</tspan>
                    </text>
                    <text class="cls-25" transform="translate(616.5 160.86)">
                      <tspan class="cls-26">#0</tspan>
                      <tspan class="cls-28" x="9.77" y="0">7</tspan>
                      <tspan class="cls-26" x="13.36" y="0">-0</tspan>
                      <tspan x="21.15" y="0">4</tspan>
                    </text>
                    <text class="cls-25" transform="translate(618.15 168.81)">
                      <tspan class="cls-26">6</tspan>
                      <tspan class="cls-27" x="4.21" y="0">7</tspan>
                      <tspan class="cls-26" x="7.79" y="0">s</tspan>
                      <tspan class="cls-28" x="11.22" y="0">q</tspan>
                      <tspan x="15.7" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(655.72 152.91)">
                      <tspan class="cls-29">C</tspan>
                      <tspan x="5.15" y="0">3</tspan>
                    </text>
                    <text class="cls-25" transform="translate(648.11 160.86)">
                      <tspan class="cls-26">#0</tspan>
                      <tspan class="cls-28" x="9.77" y="0">7</tspan>
                      <tspan class="cls-26" x="13.36" y="0">-0</tspan>
                      <tspan x="21.15" y="0">3</tspan>
                    </text>
                    <text class="cls-25" transform="translate(649.6 168.82)">
                      <tspan class="cls-26">6</tspan>
                      <tspan class="cls-27" x="4.21" y="0">7</tspan>
                      <tspan class="cls-26" x="7.79" y="0">s</tspan>
                      <tspan class="cls-28" x="11.22" y="0">q</tspan>
                      <tspan x="15.7" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(624.29 190.13)">
                      <tspan class="cls-29">C</tspan>
                      <tspan x="5.15" y="0">3</tspan>
                    </text>
                    <text class="cls-25" transform="translate(616.17 198.09)">
                      <tspan class="cls-26">#0</tspan>
                      <tspan class="cls-28" x="9.77" y="0">6</tspan>
                      <tspan class="cls-26" x="13.97" y="0">-0</tspan>
                      <tspan x="21.76" y="0">4</tspan>
                    </text>
                    <text class="cls-25" transform="translate(618.17 206.05)">
                      <tspan class="cls-26">6</tspan>
                      <tspan class="cls-27" x="4.21" y="0">7</tspan>
                      <tspan class="cls-26" x="7.79" y="0">s</tspan>
                      <tspan class="cls-28" x="11.22" y="0">q</tspan>
                      <tspan x="15.7" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(655.73 190.14)">
                      <tspan class="cls-29">C</tspan>
                      <tspan x="5.15" y="0">3</tspan>
                    </text>
                    <text class="cls-25" transform="translate(647.78 198.1)">
                      <tspan class="cls-26">#0</tspan>
                      <tspan class="cls-28" x="9.77" y="0">6</tspan>
                      <tspan class="cls-26" x="13.97" y="0">-0</tspan>
                      <tspan x="21.76" y="0">3</tspan>
                    </text>
                    <text class="cls-25" transform="translate(649.61 206.06)">
                      <tspan class="cls-26">6</tspan>
                      <tspan class="cls-27" x="4.21" y="0">7</tspan>
                      <tspan class="cls-26" x="7.79" y="0">s</tspan>
                      <tspan class="cls-28" x="11.22" y="0">q</tspan>
                      <tspan x="15.7" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(624.27 226.64)">
                      <tspan class="cls-29">C</tspan>
                      <tspan x="5.15" y="0">3</tspan>
                    </text>
                    <text class="cls-25" transform="translate(616.21 234.6)">
                      <tspan class="cls-26">#05-0</tspan>
                      <tspan x="21.72" y="0">4</tspan>
                    </text>
                    <text class="cls-25" transform="translate(618.16 242.56)">
                      <tspan class="cls-26">6</tspan>
                      <tspan class="cls-27" x="4.21" y="0">7</tspan>
                      <tspan class="cls-26" x="7.79" y="0">s</tspan>
                      <tspan class="cls-28" x="11.22" y="0">q</tspan>
                      <tspan x="15.7" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(655.72 226.65)">
                      <tspan class="cls-29">C</tspan>
                      <tspan x="5.15" y="0">3</tspan>
                    </text>
                    <text class="cls-25" transform="translate(647.83 234.61)">
                      <tspan class="cls-26">#05-0</tspan>
                      <tspan x="21.72" y="0">3</tspan>
                    </text>
                    <text class="cls-25" transform="translate(649.61 242.56)">
                      <tspan class="cls-26">6</tspan>
                      <tspan class="cls-27" x="4.21" y="0">7</tspan>
                      <tspan class="cls-26" x="7.79" y="0">s</tspan>
                      <tspan class="cls-28" x="11.22" y="0">q</tspan>
                      <tspan x="15.7" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(624.27 263.04)">
                      <tspan class="cls-29">C</tspan>
                      <tspan x="5.15" y="0">3</tspan>
                    </text>
                    <text class="cls-25" transform="translate(616.08 270.99)">
                      <tspan class="cls-26">#04-0</tspan>
                      <tspan x="21.72" y="0">4</tspan>
                    </text>
                    <text class="cls-25" transform="translate(618.15 278.95)">
                      <tspan class="cls-26">6</tspan>
                      <tspan class="cls-27" x="4.21" y="0">7</tspan>
                      <tspan class="cls-26" x="7.79" y="0">s</tspan>
                      <tspan class="cls-28" x="11.22" y="0">q</tspan>
                      <tspan x="15.7" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(655.72 263.04)">
                      <tspan class="cls-29">C</tspan>
                      <tspan x="5.15" y="0">3</tspan>
                    </text>
                    <text class="cls-25" transform="translate(647.69 271)">
                      <tspan class="cls-26">#04-0</tspan>
                      <tspan x="21.72" y="0">3</tspan>
                    </text>
                    <text class="cls-25" transform="translate(649.59 278.96)">
                      <tspan class="cls-26">6</tspan>
                      <tspan class="cls-27" x="4.21" y="0">7</tspan>
                      <tspan class="cls-26" x="7.79" y="0">s</tspan>
                      <tspan class="cls-28" x="11.22" y="0">q</tspan>
                      <tspan x="15.7" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(624.29 299.1)">
                      <tspan class="cls-29">C</tspan>
                      <tspan x="5.15" y="0">3</tspan>
                    </text>
                    <text class="cls-25" transform="translate(616.26 307.05)">
                      <tspan class="cls-26">#0</tspan>
                      <tspan class="cls-28" x="9.77" y="0">3</tspan>
                      <tspan class="cls-26" x="13.66" y="0">-0</tspan>
                      <tspan x="21.44" y="0">4</tspan>
                    </text>
                    <text class="cls-25" transform="translate(618.16 315.01)">
                      <tspan class="cls-26">6</tspan>
                      <tspan class="cls-27" x="4.21" y="0">7</tspan>
                      <tspan class="cls-26" x="7.79" y="0">s</tspan>
                      <tspan class="cls-28" x="11.22" y="0">q</tspan>
                      <tspan x="15.7" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(655.73 299.1)">
                      <tspan class="cls-29">C</tspan>
                      <tspan x="5.15" y="0">3</tspan>
                    </text>
                    <text class="cls-25" transform="translate(647.88 307.06)">
                      <tspan class="cls-26">#0</tspan>
                      <tspan class="cls-28" x="9.77" y="0">3</tspan>
                      <tspan class="cls-26" x="13.66" y="0">-0</tspan>
                      <tspan x="21.44" y="0">3</tspan>
                    </text>
                    <text class="cls-25" transform="translate(649.61 315.02)">
                      <tspan class="cls-26">6</tspan>
                      <tspan class="cls-27" x="4.21" y="0">7</tspan>
                      <tspan class="cls-26" x="7.79" y="0">s</tspan>
                      <tspan class="cls-28" x="11.22" y="0">q</tspan>
                      <tspan x="15.7" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(624.29 336.12)">
                      <tspan class="cls-29">C</tspan>
                      <tspan x="5.15" y="0">3</tspan>
                    </text>
                    <text class="cls-25" transform="translate(616.31 344.07)">
                      <tspan class="cls-26">#02-0</tspan>
                      <tspan x="21.35" y="0">4</tspan>
                    </text>
                    <text class="cls-25" transform="translate(618.16 352.03)">
                      <tspan class="cls-26">6</tspan>
                      <tspan class="cls-27" x="4.21" y="0">7</tspan>
                      <tspan class="cls-26" x="7.79" y="0">s</tspan>
                      <tspan class="cls-28" x="11.22" y="0">q</tspan>
                      <tspan x="15.7" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(655.73 336.12)">
                      <tspan class="cls-29">C</tspan>
                      <tspan x="5.15" y="0">3</tspan>
                    </text>
                    <text class="cls-25" transform="translate(647.93 344.08)">
                      <tspan class="cls-26">#02-0</tspan>
                      <tspan x="21.35" y="0">3</tspan>
                    </text>
                    <text class="cls-25" transform="translate(649.61 352.04)">
                      <tspan class="cls-26">6</tspan>
                      <tspan class="cls-27" x="4.21" y="0">7</tspan>
                      <tspan class="cls-26" x="7.79" y="0">s</tspan>
                      <tspan class="cls-28" x="11.22" y="0">q</tspan>
                      <tspan x="15.7" y="0">m</tspan>
                    </text>
                  </g>
                  <g id="A1-2" @click="setunitimg('A1')" data-name="A1">
                    <rect
                      class="cls-8"
                      x="677.47"
                      y="104.77"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-8"
                      x="677.47"
                      y="141.37"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-8"
                      x="677.47"
                      y="177.97"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-8"
                      x="677.47"
                      y="214.56"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-8"
                      x="677.47"
                      y="251.16"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-8"
                      x="677.47"
                      y="287.76"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-8"
                      x="677.47"
                      y="324.36"
                      width="30.83"
                      height="35.32"
                    />
                    <text class="cls-25" transform="translate(688.99 116.7)">
                      <tspan class="cls-26">A</tspan>
                      <tspan x="4.47" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(680.36 124.65)">
                      <tspan class="cls-26">#08-0</tspan>
                      <tspan x="21.74" y="0">2</tspan>
                    </text>
                    <text class="cls-25" transform="translate(681.82 132.61)">
                      <tspan class="cls-26">45sq</tspan>
                      <tspan x="16.24" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(689.01 152.92)">
                      <tspan class="cls-26">A</tspan>
                      <tspan x="4.47" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(680.75 160.87)">
                      <tspan class="cls-26">#0</tspan>
                      <tspan class="cls-28" x="9.77" y="0">7</tspan>
                      <tspan class="cls-26" x="13.36" y="0">-0</tspan>
                      <tspan x="21.15" y="0">2</tspan>
                    </text>
                    <text class="cls-25" transform="translate(681.84 168.83)">
                      <tspan class="cls-26">45sq</tspan>
                      <tspan x="16.24" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(689.02 190.15)">
                      <tspan class="cls-26">A</tspan>
                      <tspan x="4.47" y="0">1</tspan>
                    </text>
                    <text class="cls-30" transform="translate(680.42 198.1)">
                      #0
                      <tspan class="cls-28" x="9.77" y="0">6</tspan>
                      <tspan x="13.97" y="0">-0</tspan>
                      <tspan class="cls-31" x="21.76" y="0">2</tspan>
                    </text>
                    <text class="cls-25" transform="translate(681.84 206.06)">
                      <tspan class="cls-26">45sq</tspan>
                      <tspan x="16.24" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(689.01 226.66)">
                      <tspan class="cls-26">A</tspan>
                      <tspan x="4.47" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(680.47 234.61)">
                      <tspan class="cls-26">#05-0</tspan>
                      <tspan x="21.72" y="0">2</tspan>
                    </text>
                    <text class="cls-25" transform="translate(681.83 242.57)">
                      <tspan class="cls-26">45sq</tspan>
                      <tspan x="16.24" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(689 263.05)">
                      <tspan class="cls-26">A</tspan>
                      <tspan x="4.47" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(680.33 271.01)">
                      <tspan class="cls-26">#04-0</tspan>
                      <tspan x="21.72" y="0">2</tspan>
                    </text>
                    <text class="cls-25" transform="translate(681.83 278.96)">
                      <tspan class="cls-26">45sq</tspan>
                      <tspan x="16.24" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(689.01 299.11)">
                      <tspan class="cls-26">A</tspan>
                      <tspan x="4.47" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(680.51 307.07)">
                      <tspan class="cls-26">#0</tspan>
                      <tspan class="cls-28" x="9.77" y="0">3</tspan>
                      <tspan class="cls-26" x="13.66" y="0">-0</tspan>
                      <tspan x="21.44" y="0">2</tspan>
                    </text>
                    <text class="cls-25" transform="translate(681.84 315.02)">
                      <tspan class="cls-26">45sq</tspan>
                      <tspan x="16.24" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(689.02 336.13)">
                      <tspan class="cls-26">A</tspan>
                      <tspan x="4.47" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(680.57 344.09)">
                      <tspan class="cls-26">#02-0</tspan>
                      <tspan x="21.35" y="0">2</tspan>
                    </text>
                    <text class="cls-25" transform="translate(681.84 352.04)">
                      <tspan class="cls-26">45sq</tspan>
                      <tspan x="16.24" y="0">m</tspan>
                    </text>
                  </g>
                  <g id="B2" @click="setunitimg('B2')">
                    <rect
                      class="cls-13"
                      x="709.58"
                      y="104.77"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-13"
                      x="709.58"
                      y="141.37"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-13"
                      x="709.58"
                      y="177.97"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-13"
                      x="709.58"
                      y="214.56"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-13"
                      x="709.58"
                      y="251.16"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-13"
                      x="709.58"
                      y="287.76"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-13"
                      x="709.58"
                      y="324.36"
                      width="30.83"
                      height="35.32"
                    />
                    <text class="cls-25" transform="translate(720.38 116.7)">
                      <tspan class="cls-26">B</tspan>
                      <tspan x="4.05" y="0">2</tspan>
                    </text>
                    <text class="cls-25" transform="translate(712.72 124.66)">
                      <tspan class="cls-26">#08-0</tspan>
                      <tspan x="21.74" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(713.65 132.62)">
                      <tspan class="cls-29">55s</tspan>
                      <tspan class="cls-28" x="11.74" y="0">q</tspan>
                      <tspan x="16.22" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(720.4 152.92)">
                      <tspan class="cls-26">B</tspan>
                      <tspan x="4.05" y="0">2</tspan>
                    </text>
                    <text class="cls-25" transform="translate(713.11 160.88)">
                      <tspan class="cls-26">#0</tspan>
                      <tspan class="cls-28" x="9.77" y="0">7</tspan>
                      <tspan class="cls-26" x="13.36" y="0">-0</tspan>
                      <tspan x="21.15" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(713.67 168.84)">
                      <tspan class="cls-29">55s</tspan>
                      <tspan class="cls-28" x="11.74" y="0">q</tspan>
                      <tspan x="16.22" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(720.4 190.15)">
                      <tspan class="cls-26">B</tspan>
                      <tspan x="4.05" y="0">2</tspan>
                    </text>
                    <text class="cls-25" transform="translate(712.77 198.11)">
                      <tspan class="cls-26">#0</tspan>
                      <tspan class="cls-28" x="9.77" y="0">6</tspan>
                      <tspan class="cls-26" x="13.97" y="0">-0</tspan>
                      <tspan x="21.76" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(713.67 206.07)">
                      <tspan class="cls-29">55s</tspan>
                      <tspan class="cls-28" x="11.74" y="0">q</tspan>
                      <tspan x="16.22" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(720.39 226.66)">
                      <tspan class="cls-26">B</tspan>
                      <tspan x="4.05" y="0">2</tspan>
                    </text>
                    <text class="cls-25" transform="translate(712.82 234.62)">
                      <tspan class="cls-26">#05-0</tspan>
                      <tspan x="21.72" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(713.66 242.58)">
                      <tspan class="cls-29">55s</tspan>
                      <tspan class="cls-28" x="11.74" y="0">q</tspan>
                      <tspan x="16.22" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(720.38 263.06)">
                      <tspan class="cls-26">B</tspan>
                      <tspan x="4.05" y="0">2</tspan>
                    </text>
                    <text class="cls-25" transform="translate(712.69 271.01)">
                      <tspan class="cls-26">#04-0</tspan>
                      <tspan x="21.72" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(713.66 278.97)">
                      <tspan class="cls-29">55s</tspan>
                      <tspan class="cls-28" x="11.74" y="0">q</tspan>
                      <tspan x="16.22" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(720.4 299.12)">
                      <tspan class="cls-26">B</tspan>
                      <tspan x="4.05" y="0">2</tspan>
                    </text>
                    <text class="cls-25" transform="translate(712.87 307.08)">
                      <tspan class="cls-26">#0</tspan>
                      <tspan class="cls-28" x="9.77" y="0">3</tspan>
                      <tspan class="cls-26" x="13.66" y="0">-0</tspan>
                      <tspan x="21.44" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(713.67 315.03)">
                      <tspan class="cls-29">55s</tspan>
                      <tspan class="cls-28" x="11.74" y="0">q</tspan>
                      <tspan x="16.22" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(720.4 336.14)">
                      <tspan class="cls-26">B</tspan>
                      <tspan x="4.05" y="0">2</tspan>
                    </text>
                    <text class="cls-25" transform="translate(712.92 344.09)">
                      <tspan class="cls-26">#02-0</tspan>
                      <tspan x="21.35" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(713.67 352.05)">
                      <tspan class="cls-29">55s</tspan>
                      <tspan class="cls-28" x="11.74" y="0">q</tspan>
                      <tspan x="16.22" y="0">m</tspan>
                    </text>
                  </g>
                  <g id="G2" @click="setunitimg('G2')">
                    <rect
                      class="cls-11"
                      x="131.69"
                      y="214.56"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-11"
                      x="131.69"
                      y="251.16"
                      width="30.83"
                      height="35.32"
                    />
                    <text class="cls-25" transform="translate(142.31 262.71)">
                      <tspan class="cls-28">G</tspan>
                      <tspan x="5.18" y="0">2</tspan>
                    </text>
                    <text class="cls-25" transform="translate(135.07 270.67)">
                      <tspan class="cls-26">#04-1</tspan>
                      <tspan x="19.6" y="0">9</tspan>
                    </text>
                    <text class="cls-25" transform="translate(134.66 278.63)">
                      <tspan class="cls-26">102sq</tspan>
                      <tspan x="17.9" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(142.32 226.46)">
                      <tspan class="cls-28">G</tspan>
                      <tspan x="5.18" y="0">2</tspan>
                    </text>
                    <text class="cls-25" transform="translate(135.21 234.42)">
                      <tspan class="cls-26">#05-1</tspan>
                      <tspan x="19.6" y="0">9</tspan>
                    </text>
                    <text class="cls-25" transform="translate(134.67 242.37)">
                      <tspan class="cls-26">102sq</tspan>
                      <tspan x="17.9" y="0">m</tspan>
                    </text>
                  </g>
                  <g id="G1" @click="setunitimg('G1')">
                    <rect
                      class="cls-11"
                      x="195.9"
                      y="214.56"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-11"
                      x="195.9"
                      y="251.16"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-11"
                      x="195.9"
                      y="287.76"
                      width="30.83"
                      height="35.32"
                    />
                    <rect
                      class="cls-11"
                      x="195.9"
                      y="324.36"
                      width="30.83"
                      height="35.32"
                    />
                    <text class="cls-25" transform="translate(207.13 262.72)">
                      <tspan class="cls-28">G</tspan>
                      <tspan x="5.18" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(199.59 270.68)">
                      <tspan class="cls-26">#04-1</tspan>
                      <tspan x="19.6" y="0">7</tspan>
                    </text>
                    <text class="cls-25" transform="translate(200.06 278.63)">
                      <tspan class="cls-26">95sq</tspan>
                      <tspan x="16.24" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(207.13 298.68)">
                      <tspan class="cls-28">G</tspan>
                      <tspan x="5.18" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(199.76 306.63)">
                      <tspan class="cls-26">#03</tspan>
                      <tspan class="cls-28" x="13.66" y="0">-</tspan>
                      <tspan class="cls-29" x="17.28" y="0">1</tspan>
                      <tspan x="19.32" y="0">7</tspan>
                    </text>
                    <text class="cls-25" transform="translate(200.06 314.59)">
                      <tspan class="cls-26">95sq</tspan>
                      <tspan x="16.24" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(207.13 335.59)">
                      <tspan class="cls-28">G</tspan>
                      <tspan x="5.18" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(199.81 343.55)">
                      <tspan class="cls-26">#02-1</tspan>
                      <tspan x="19.23" y="0">7</tspan>
                    </text>
                    <text class="cls-25" transform="translate(200.06 351.51)">
                      <tspan class="cls-26">95sq</tspan>
                      <tspan x="16.24" y="0">m</tspan>
                    </text>
                    <text class="cls-25" transform="translate(207.14 226.47)">
                      <tspan class="cls-28">G</tspan>
                      <tspan x="5.18" y="0">1</tspan>
                    </text>
                    <text class="cls-25" transform="translate(199.73 234.42)">
                      <tspan class="cls-26">#05-1</tspan>
                      <tspan x="19.6" y="0">7</tspan>
                    </text>
                    <text class="cls-25" transform="translate(200.06 242.38)">
                      <tspan class="cls-26">95sq</tspan>
                      <tspan x="16.24" y="0">m</tspan>
                    </text>
                  </g>
                  <rect
                    class="cls-12"
                    x="67.48"
                    y="324.36"
                    width="30.83"
                    height="35.32"
                  />
                  <text class="cls-23" transform="translate(76.27 344.84)">
                    CF
                  </text>
                </g>
              </g>
            </g>
          </svg>
        </div>
        <div
          v-else
          style="
            -webkit-user-drag: none;
            user-select: none;
            pointer-events: none;
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
          "
        >
          <img
            :class="`buildingzoomcls${index}`"
            style="width: auto; height: auto; max-width: 100%; max-height: 80%"
            :src="unit_img_url"
          />
        </div>
      </motion>
      <!-- <div >
        {{fangm}},{{width}},{{height}},{{top}},
        {{ left}}
      </div>-->

      <div v-if="!comparison_div1" class="Buildingsvg_btn_group">
        <div @click="imgzoom()">
          <svg
            t="1598077082941"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="4039"
            width="20"
            height="20"
          >
            <path
              d="M460.8 51.2a409.6 409.6 0 0 1 323.1232 661.3504c2.3552 1.536 4.608 3.4304 6.656 5.5296l202.24 202.24a51.2 51.2 0 0 1-72.3968 72.3968l-202.24-202.24a51.5584 51.5584 0 0 1-5.632-6.656A409.6 409.6 0 1 1 460.8 51.2z m0 102.4a307.2 307.2 0 1 0 0 614.4A307.2 307.2 0 0 0 460.8 153.6z"
              p-id="4040"
              fill="#ffffff"
            />
          </svg>
        </div>
        <div @click="(comparison_div1 = !comparison_div1), resetzoom()">
          <svg
            t="1598083388080"
            class="icon"
            viewBox="0 0 1084 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="23260"
            width="20"
            height="20"
          >
            <path
              d="M788.804292 977.500541a503.543363 503.543363 0 0 0 162.507176-119.862595 509.687074 509.687074 0 0 0 103.780528-174.312738 515.047762 515.047762 0 0 0 28.550186-194.068985 514.385205 514.385205 0 0 0-45.53574-190.816432 508.663122 508.663122 0 0 0-118.657945-164.193685A501.676156 501.676156 0 0 0 554.921651 0.530046 503.904757 503.904757 0 0 0 203.585714 166.530704a509.807538 509.807538 0 0 0-94.564962 150.159522L0 290.187944l45.174345 154.014399 45.234577 154.0144 109.382147-116.610042L309.173215 365.056891l-103.057738-24.936238a411.387699 411.387699 0 0 1 69.990118-106.611453 405.846313 405.846313 0 0 1 576.906499-25.960191c166.181356 153.592772 177.625524 415.001647 25.659027 582.869512a406.087243 406.087243 0 0 1-577.026963 25.899958l-66.315938 73.302904a502.097784 502.097784 0 0 0 364.707543 133.836525 499.387323 499.387323 0 0 0 188.768529-45.957367z"
              p-id="23261"
              fill="#ffffff"
            />
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
import motion from "@/components/motion.vue";

export default {
  name: "buildingsvg",
  components: {
    motion,
  },
  data() {
    return {
      // onDragStartCallback:true,
      comparison_div1: true,
      comparison_div2: true,
      contrast: false,
      fangm: 1,
      width: 1080,
      height: 1500,
      top: 10,
      left: 10,
      imgzoomtype: true,
      start: [],
      zoomtype: true,
      zoomsizes: 1,
    };
  },
  props: {
    index: {
      type: Number,
    },
    unit_img_url: {
      type: String,
    },
    zoom: {
      type: Number,
    },
  },
  methods: {
    setzoomsize(data) {
      this.zoomsizes = data;
    },
    setunitimg(e) {
      // console.log(e);
      this.zoomsizes = 1;
      console.log("点击户型", this.zoomsizes);
      this.unit_img_url = require(`../assets/unit/${e}.png`);
      this.comparison_div1 = !this.comparison_div1;
    },

    imgzoom() {
      let op = document.getElementsByClassName(
        `buildingzoomcls${this.index}`
      )[0];
      if (this.zoomtype) {
        this.zoomsizes = 1;
        // op.style = "transform: scale(0.5);";
      } else {
        this.zoomsizes = 1.5;
        // op.style = "transform: scale(0.3);";
      }
      this.zoomtype = !this.zoomtype;
    },
    resetzoom(e) {
      // 重置
      this.fangm = 1;
      this.width = 800;
      this.height = 1000;
      this.top = 10;
      this.left = 10;
      this.zoomsizes = 1;
      // this.executezoom();
      console.log("重置", this.zoomsizes);
    },
  },
  mounted() {
    if (this.index == 1) {
      this.comparison_div1 = false;
    } else {
      this.comparison_div1 = true;
    }
    // this.unit_img_url
  },
};
</script>

<style>
@import "~@/style/css/svg.css";

.zoom_btn_div {
  width: auto;
  bottom: 5%;
  right: 15px;
  position: absolute;
  display: grid;
}
.zoom_btn_div div {
  color: #000;
  line-height: 10px;
  /* margin: 2px; */
  width: 25px;
  height: 25px;
  background: rgb(255, 255, 255);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 23px;
}

.img_zoom {
  overflow: hidden;
  position: relative;
  width: 100%;
  height: 100%;
  /* border: 1px solid rgb(161, 160, 160); */
}

.img_contrast {
  width: 100%;
  height: 100%;
  background: white !important;
  overflow: hidden;
  display: flex;
  /* grid-template-rows: 90% 10%; */
}

.Buildingsvg_btn_group {
  position: absolute;
  width: 60px;
  height: auto;
  top: 15px;
  right: 15px;
  display: flex;
  justify-content: space-between;
  background: gray;
  padding: 10px;
  color: white;
}
.Buildingsvg_btn_group div {
  line-height: 20px;
  height: 20px;
  cursor: pointer;
}
</style>
